export const multilingualSupport = {
    'English': {
        "language": "Change Language",

        "qbag": "Question Bank Generator",

        "qbagDescp1": "Question Bank Generator uses a crowd sourcing model to prepare question banks from a large pool of objective questions. QBaG provides an interface for paper setters and academicians to generate reliable question papers using our automated and robust system. The questions can be selected based on a range of parameters and can be exported to your desired format within minutes. Each question contributed is passed through a number of checks and is also vetted by experts.",

        "qbagDescp2": "This app is built by Team-Executables",

        "homeBanner1": "CROWDSOURCED QUESTIONS",
        "homeBanner1.2": "Get questions from various sources",
        "homeBanner1.3": "Crowdsourcing enables all the users to contribute, this helps in gathering multiple viewpoints and diversifies the archive of questions. Crowdsourcing reduces the management burden as the major work is handled by the system which frees the user from manual work",

        "homeBanner2": "RELIABLE QUESTIONS",
        "homeBanner2.2": "Verified and validated questions",
        "homeBanner2.3": "Each question contributed passes through a series of automated test, which is then scrutinised by experts",

        "homeBanner3": "EXPORT",
        "homeBanner3.2": "Export the questions in the desired format",
        "homeBanner3.3": "The selected questions can be converted into a question paper and can be exported into PDF, CSV or excel format",

        "homeBanner4": "FILTERING OPTIONS",
        "homeBanner4.2": "Choose from a variety of questions",
        "homeBanner4.3": "Filter and choose questions based on board, class, difficulty, marks, number of questions and other parameters to get the perfect list of curated questions",


        "qbagDescp3": "Create your account now, and use QBaG as your paper setter assistant.",
        "qbagDescp4": "To explore more features of QBaG, create an account to get started.",
        "footer": "Follow us on",

        "register": "Register",
        "login": "Login",
        "name": "Name",
        "employment": "Employment",
        "dragNDropProof": "Drag 'n' Drop or select a valid identity proof",
        "uploadPhotoID": "Uload Photo ID",
        "email": "Email Address",
        "userType": "User Type",
        "teacherType": "Teacher",
        "othersType": "Others",
        "schoolCollege": "School/College",
        "position": "Position",
        "education": "Education",
        "password": "Password",
        "forgotPassword": "Forgot password?",
        "dontHaveAnAccountSignUp": "Don't have an account? Sign Up",
        "alreadyHaveAnAccountSignIn": "Already have an account? Sign in",


        "addQuestion": "Add Question",
        "searchQuestion": "Search Question",
        "generateQuestionPaper": "Generate Question Paper",
        "viewPastPapers": "Generated Papers",
        "noQuestionsFound": "Sorry, No Questions Found",
        "contributeQuestions": "Contribute Questions",
        "myQuestions": "My Questions",
        "myTemplates": "My Templates",


        "questionDetails": "Question Details",
        "board": "Board",
        "langMedium": "Medium of Board",
        "grade": "Grade",
        "questionType": "Question Type",
        "mcq": "Multiple Choice Question",
        "oneWord": "One Word or Sentence",
        "fillInTheBlanks": "Fill in the Blanks",
        "matchTheFollowing": "Match the Following",
        "difficulty": "Difficulty",
        "easy": "Easy",
        "medium": "Medium",
        "hard": "Hard",
        "mark": "Mark",
        "marks": "Marks",
        "subject": "Subject",
        "typeKeywordsAndPressEnter": "Type Keywords and Press Enter",
        "question": "Question",
        "questions": "Questions",
        "numQuestions": "No. of questions",
        "key": "Key",
        "value": "Value",
        "addNew": "Add New",
        "remove": "Remove",
        "answer": "Answer",
        "answers": "Answers",
        "columnA": "Column A",
        "columnB": "Column B",
        "correctOption": "Correct Option",
        "wrongOpts": "Wrong Options",
        "wrongOption": "Type Wrong Options and Press Enter",
        "back": "Back",
        "next": "Next",

        "enterQuestion": "Enter Question",
        "addAnotherQuestion": "Add Another Question",
        "enterQuestionSuccess": "Thank you for your Question.",
        "enterQuestionError": "OOPS! a similar question already exists!",
        "search": "Search",
        "exportPDF": "Print to PDF",
        "reviewQuestion": "Review Question",
        "submitQuestion": "Submit Question",

        "invalidRegistration": "Invalid Registration Data! Please Try Again",
        "verifyEmail": "An email verification link has been sent on the given email address.\nPlease verify your email to complete the account setup.\nVerification link is valid for 24 hrs",

        "loginError1": "Invalid Login Credentials! Please Try Again",
        "loginError2": "Please validate your email! Check your inbox",

        "dashboard": "Dashboard",
        "viewIDProof": "View ID Proof",

        "changePassword": "Change Password",
        "changePasswordError": "Old password is incorrect. Please Try Again",
        "oldPassword": "Old Password",
        "newPassword": "New Password",
        "confirmNewPassword": "Confirm New Password",

        "logout": "Logout",
        "ok": "OK",
        "submit": "Submit",
        "change": "CHANGE",
        "backToHome": "Back to Home",
        "pageNotFound": "Page Not Found",

        "getResetLink": "Enter Email to Get your Password Reset Link",
        "enterNewPassword": "Enter your New Password",
        "resetPasswordAlertTitle": "Password Changed Successfully",
        "resetPasswordAlertDescription": "Your password has been reset successfully.\nPlease proceed to login",
        "resetPasswordError": "Reset Link has Expired! Please Try Again",

        "forgotPasswordError": "Invalid email ID! Please Try Again",
        "forgotPasswordAlertTitle": "Reset Password Link",
        "forgotPasswordAlertDescription": "A reset password link has been sent on the given email address.\nPlease click on the link to set your new password.\nReset link is valid for 24 hrs",

        "selectQuestions": "Select Questions",
        "selectedQuestions": "Questions Selected",
        "reviewQuestions": "Review Questions",
        "generatePaper": "Generate Paper",
        "savePaper": "Save Paper",
        "easyQuestions": "No. of Easy questions",
        "mediumQuestions": "No. of Medium questions",
        "hardQuestions": "No. of Hard questions",
        "totalQuestions": "Total No. of questions",
        "totalMarks": "Total Marks",
        "mcqs": "No. of Multiple Choice Questions",
        "oneWords": "No. of One Word/Sentence Questions",
        "fillInTheBlankss": "No. Fill in the Blanks Questions",
        "matchTheFollowings": "No. Match the Following Questions",

        "paperName": "Paper Name",
        "vettedWarning": "The following questions are not vetted by the community, would you still like to continue?",
        "requested": "Requested",
        "selected": "Selected",
        "noPapersGenerated": "No Question Papers are generated yet",
        "noTemplatesSaved": "You have not saved any templates",
        "savePrompt": "Save this search as a Template",
        "save": "Save",

        "downvoteModalHead": "Reason for Downvote",
        "downvoteModalSubHead": "Please provide a reason for downvoting the question",
        "cancel": "Cancel",

        "extraQuestions": "% of Extra Questions",

        "noSpeechSupport": "Browser doesn't support speech recognition",
        "uploadCSV": "Upload CSV File",
        "submitFile": "Submit file",
        "downloadSample": "Download Sample",
        "sorryNote": "We are sorry! No questions found for this paper. They may have been marked invalid by the community and hence deleted from our servers."
    },
    'हिन्दी': {'language': 'भाषा बदलो',
  'qbag': 'प्रश्न बैंक जेनरेटर',
  'qbagDescp1': 'प्रश्न बैंक जेनरेटर वस्तुनिष्ठ प्रश्नों के एक बड़े पूल से प्रश्न बैंक तैयार करने के लिए क्राउड सोर्सिंग मॉडल का उपयोग करता है। QBaG हमारे स्वचालित और मजबूत सिस्टम का उपयोग करके विश्वसनीय प्रश्न पत्र तैयार करने के लिए पेपर सेटर्स और शिक्षाविदों के लिए एक इंटरफ़ेस प्रदान करता है। प्रश्नों को कई मापदंडों के आधार पर चुना जा सकता है और मिनटों के भीतर आपके वांछित प्रारूप में निर्यात किया जा सकता है। योगदान किए गए प्रत्येक प्रश्न को कई जांचों के माध्यम से पारित किया जाता है और विशेषज्ञों द्वारा इसकी जांच भी की जाती है।',
  'qbagDescp2': 'यह ऐप Team-Executables . द्वारा बनाया गया है',
  'homeBanner1': 'भीड़-भाड़ वाले प्रश्न',
  'homeBanner1.2': 'विभिन्न स्रोतों से प्रश्न प्राप्त करें',
  'homeBanner1.3': 'क्राउडसोर्सिंग सभी उपयोगकर्ताओं को योगदान करने में सक्षम बनाता है, यह कई दृष्टिकोणों को इकट्ठा करने में मदद करता है और प्रश्नों के संग्रह में विविधता लाता है। क्राउडसोर्सिंग प्रबंधन के बोझ को कम करता है क्योंकि प्रमुख कार्य उस प्रणाली द्वारा नियंत्रित किया जाता है जो उपयोगकर्ता को मैनुअल काम से मुक्त करता है',
  'homeBanner2': 'विश्वसनीय प्रश्न',
  'homeBanner2.2': 'सत्यापित और मान्य प्रश्न',
  'homeBanner2.3': 'योगदान दिया गया प्रत्येक प्रश्न स्वचालित परीक्षण की एक श्रृंखला से होकर गुजरता है, जिसे तब विशेषज्ञों द्वारा जांचा जाता है',
  'homeBanner3': 'निर्यात करना',
  'homeBanner3.2': 'प्रश्नों को वांछित प्रारूप में निर्यात करें',
  'homeBanner3.3': 'चयनित प्रश्नों को प्रश्न पत्र में परिवर्तित किया जा सकता है और पीडीएफ, सीएसवी या एक्सेल प्रारूप में निर्यात किया जा सकता है',
  'homeBanner4': 'निस्पंदन विकल्प',
  'homeBanner4.2': 'विभिन्न प्रश्नों में से चुनें',
  'homeBanner4.3': 'क्यूरेटेड प्रश्नों की सही सूची प्राप्त करने के लिए बोर्ड, कक्षा, कठिनाई, अंक, प्रश्नों की संख्या और अन्य मापदंडों के आधार पर प्रश्नों को फ़िल्टर करें और चुनें',
  'qbagDescp3': 'अभी अपना खाता बनाएं, और QBaG को अपने पेपर सेटर सहायक के रूप में उपयोग करें।',
  'qbagDescp4': 'QBaG की अधिक सुविधाओं का पता लगाने के लिए, आरंभ करने के लिए एक खाता बनाएं।',
  'footer': 'पर हमें का पालन करें',
  'register': 'रजिस्टर करें',
  'login': 'लॉग इन करें',
  'name': 'उपनाम',
  'employment': 'रोज़गार',
  'dragNDropProof': "'n' ड्रॉप खींचें या एक मान्य पहचान प्रमाण चुनें",
  'uploadPhotoID': 'फोटो आईडी अपलोड करें',
  'email': 'ईमेल पता',
  'userType': 'उपयोगकर्ता का प्रकार',
  'teacherType': 'शिक्षक',
  'othersType': 'अन्य',
  'schoolCollege': 'स्कूल कॉलेज',
  'position': 'स्थान',
  'education': 'शिक्षा',
  'password': 'पासवर्ड',
  'forgotPassword': 'पासवर्ड भूल गए?',
  'dontHaveAnAccountSignUp': 'खाता नहीं है? साइन अप करें',
  'alreadyHaveAnAccountSignIn': 'क्या आपके पास पहले से एक खाता मौजूद है? साइन इन करें',
  'addQuestion': 'प्रश्न जोड़ें',
  'searchQuestion': 'खोज प्रश्न',
  'generateQuestionPaper': 'प्रश्न पत्र उत्पन्न करें',
  'viewPastPapers': 'उत्पन्न कागजात',
  'noQuestionsFound': 'क्षमा करें, कोई प्रश्न नहीं मिला',
  'contributeQuestions': 'योगदान प्रश्न',
  'myQuestions': 'मेरे सवाल',
  'myTemplates': 'मेरे टेम्पलेट्स',
  'questionDetails': 'प्रश्न का विवरण',
  'board': 'तख्ता',
  'langMedium': 'बोर्ड का माध्यम',
  'grade': 'जाल',
  'questionType': 'प्रश्न प्रकार',
  'mcq': 'बहु विकल्पीय प्रश्न',
  'oneWord': 'एक शब्द या वाक्य',
  'fillInTheBlanks': 'रिक्त स्थान भरें',
  'matchTheFollowing': 'निम्नलिखित को मिलाएं',
  'difficulty': 'कठिनाई',
  'easy': 'आसान',
  'medium': 'मध्यम',
  'hard': 'कठिन',
  'mark': 'निशान',
  'marks': 'निशान',
  'subject': 'विषय',
  'typeKeywordsAndPressEnter': 'विषय टाइप करें और एंटर दबाएं',
  'question': 'प्रश्न',
  'questions': 'प्रशन',
  'numQuestions': 'प्रश्नों की संख्या',
  'key': 'चाभी',
  'value': 'मूल्य',
  'addNew': 'नया जोड़ो',
  'remove': 'हटाना',
  'answer': 'उत्तर',
  'answers': 'जवाब',
  'columnA': 'कॉलम ए',
  'columnB': 'कॉलम बी',
  'correctOption': 'सही विकल्प',
  'wrongOpts': 'गलत विकल्प',
  'wrongOption': 'गलत विकल्प टाइप करें और एंटर दबाएं',
  'back': 'पीछे',
  'next': 'अगला',
  'enterQuestion': 'प्रश्न दर्ज करें',
  'addAnotherQuestion': 'एक और प्रश्न जोड़ें',
  'enterQuestionSuccess': 'आपके सवाल के लिए धन्यवाद।',
  'enterQuestionError': 'उफ़! ऐसा ही एक प्रश्न पहले से मौजूद है!',
  'search': 'खोज',
  'exportPDF': 'पीडीएफ में प्रिंट करें',
  'reviewQuestion': 'समीक्षा प्रश्न',
  'submitQuestion': 'प्रश्न सबमिट करें',
  'invalidRegistration': 'अमान्य पंजीकरण डेटा! कृपया पुन: प्रयास करें',
  'verifyEmail': 'दिए गए ईमेल पते पर एक ईमेल सत्यापन लिंक भेजा गया है।\nखाता सेटअप पूरा करने के लिए कृपया अपना ईमेल सत्यापित करें।\nसत्यापन लिंक 24 घंटे के लिए वैध है',
  'loginError1': 'अमान्य प्रवेश करना प्रत्यायक! कृपया पुन: प्रयास करें',
  'loginError2': 'कृपया अपना ईमेल सत्यापित करें! अपने इनबॉक्स की जाँच करें',
  'dashboard': 'डैशबोर्ड',
  'viewIDProof': 'आईडी प्रमाण देखें',
  'changePassword': 'पासवर्ड बदलें',
  'changePasswordError': 'पुराना पासवर्ड गलत है। कृपया पुन: प्रयास करें',
  'oldPassword': 'पुराना पासवर्ड',
  'newPassword': 'नया पासवर्ड',
  'confirmNewPassword': 'नए पासवर्ड की पुष्टि करें',
  'logout': 'लॉग आउट',
  'ok': 'ठीक है',
  'submit': 'प्रस्तुत करना',
  'change': 'परिवर्तन',
  'backToHome': 'घर वापिस जा रहा हूँ',
  'pageNotFound': 'पृष्ठ नहीं मिला',
  'getResetLink': 'अपना पासवर्ड रीसेट लिंक प्राप्त करने के लिए ईमेल दर्ज करें',
  'enterNewPassword': 'अपना नया पासवर्ड दर्ज करें',
  'resetPasswordAlertTitle': 'पासवर्ड सफलतापूर्वक बदला गया',
  'resetPasswordAlertDescription': 'आपका पासवर्ड सफलतापूर्वक रीसेट कर दिया गया है।\nकृपया लॉगिन करने के लिए आगे बढ़ें',
  'resetPasswordError': 'रीसेट लिंक की समय सीमा समाप्त हो गई है! कृपया पुन: प्रयास करें',
  'forgotPasswordError': 'अमान्य ईमेल आईडी! कृपया पुन: प्रयास करें',
  'forgotPasswordAlertTitle': 'पासवर्ड रीसेट करें लिंक',
  'forgotPasswordAlertDescription': 'दिए गए ईमेल पते पर एक रीसेट पासवर्ड लिंक भेजा गया है।\nअपना नया पासवर्ड सेट करने के लिए कृपया लिंक पर क्लिक करें।\nरीसेट लिंक 24 घंटे के लिए वैध है',
  'selectQuestions': 'प्रश्नों का चयन करें',
  'selectedQuestions': 'चयनित प्रश्न',
  'reviewQuestions': 'समीक्षा प्रश्न',
  'generatePaper': 'कागज उत्पन्न करें',
  'savePaper': 'कागज बचाओ',
  'easyQuestions': 'आसान प्रश्नों की संख्या',
  'mediumQuestions': 'मध्यम प्रश्नों की संख्या',
  'hardQuestions': 'कठिन प्रश्नों की संख्या',
  'totalQuestions': 'प्रश्नों की कुल संख्या',
  'totalMarks': 'कुल मार्क',
  'mcqs': 'बहुविकल्पीय प्रश्नों की संख्या',
  'oneWords': 'एक शब्द/वाक्य के प्रश्नों की संख्या',
  'fillInTheBlankss': 'नहीं, रिक्त स्थान भरें प्रश्न',
  'matchTheFollowings': 'नहीं। निम्नलिखित प्रश्नों का मिलान करें',
  'paperName': 'कागज का नाम',
  'vettedWarning': 'निम्नलिखित प्रश्नों की समुदाय द्वारा जांच नहीं की जाती है, क्या आप अब भी जारी रखना चाहेंगे?',
  'requested': 'का अनुरोध किया',
  'selected': 'चयनित',
  'noPapersGenerated': 'अभी तक कोई प्रश्न पत्र उत्पन्न नहीं हुआ है',
  'noTemplatesSaved': 'आपने कोई टेम्पलेट सहेजा नहीं है',
  'savePrompt': 'इस खोज को टेम्पलेट के रूप में सहेजें',
  'save': 'सावा',
  'downvoteModalHead': 'डाउनवोट का कारण',
  'downvoteModalSubHead': 'कृपया प्रश्न को कम करने का एक कारण प्रदान करें',
  'cancel': 'रद्द करना',
  'noSpeechSupport': 'ब्राउज़र वाक् पहचान का समर्थन नहीं करता',
  'uploadCSV': 'CSV फ़ाइल अपलोड करें',
  'submitFile': 'फ़ाइलें जमा करें',
  'downloadSample': 'नमूना डाउनलोड करें',
        'sorryNote': 'हमें खेद है! इस पेपर के लिए कोई प्रश्न नहीं मिला। हो सकता है कि उन्हें समुदाय द्वारा अमान्य चिह्नित किया गया हो और इसलिए हमारे सर्वर से हटा दिया गया हो।',
    'extraQuestions': 'अतिरिक्त प्रश्नों का %'
    },
 'ગુજરાતી': {'language': 'ભાષા બદલો',
  'qbag': 'પ્રશ્ન બેંક જનરેટર',
  'qbagDescp1': 'પ્રશ્ન બેંક જનરેટર ઉદ્દેશ્ય પ્રશ્નોના વિશાળ પૂલમાંથી પ્રશ્ન બેંક તૈયાર કરવા માટે ક્રાઉડ સોર્સિંગ મોડલનો ઉપયોગ કરે છે. QBaG પેપર સેટર્સ અને શિક્ષણવિદો માટે અમારી સ્વચાલિત અને મજબૂત સિસ્ટમનો ઉપયોગ કરીને વિશ્વસનીય પ્રશ્નપત્રો જનરેટ કરવા માટે ઇન્ટરફેસ પ્રદાન કરે છે. પરિમાણોની શ્રેણીના આધારે પ્રશ્નો પસંદ કરી શકાય છે અને મિનિટોમાં તમારા ઇચ્છિત ફોર્મેટમાં નિકાસ કરી શકાય છે. યોગદાન આપેલ દરેક પ્રશ્ન સંખ્યાબંધ તપાસમાંથી પસાર થાય છે અને નિષ્ણાતો દ્વારા તેની ચકાસણી પણ કરવામાં આવે છે.',
  'qbagDescp2': 'આ એપ્લિકેશન ટીમ-એક્ઝીક્યુટેબલ્સ દ્વારા બનાવવામાં આવી છે',
  'homeBanner1': 'ક્રાઉડસોર્સ પ્રશ્નો',
  'homeBanner1.2': 'વિવિધ સ્ત્રોતોમાંથી પ્રશ્નો મેળવો',
  'homeBanner1.3': 'ક્રાઉડસોર્સિંગ તમામ વપરાશકર્તાઓને યોગદાન આપવા માટે સક્ષમ બનાવે છે, આ બહુવિધ દૃષ્ટિકોણ એકત્ર કરવામાં મદદ કરે છે અને પ્રશ્નોના આર્કાઇવને વૈવિધ્ય બનાવે છે. ક્રાઉડસોર્સિંગ મેનેજમેન્ટ બોજ ઘટાડે છે કારણ કે મુખ્ય કાર્ય સિસ્ટમ દ્વારા નિયંત્રિત થાય છે જે વપરાશકર્તાને મેન્યુઅલ વર્કમાંથી મુક્ત કરે છે',
  'homeBanner2': 'ભરોસાપાત્ર પ્રશ્નો',
  'homeBanner2.2': 'ચકાસાયેલ અને માન્ય પ્રશ્નો',
  'homeBanner2.3': 'યોગદાન આપેલ દરેક પ્રશ્ન સ્વયંસંચાલિત કસોટીની શ્રેણીમાંથી પસાર થાય છે, જે પછી નિષ્ણાતો દ્વારા તપાસવામાં આવે છે',
  'homeBanner3': 'નિકાસ કરો',
  'homeBanner3.2': 'ઇચ્છિત ફોર્મેટમાં પ્રશ્નો નિકાસ કરો',
  'homeBanner3.3': 'પસંદ કરેલા પ્રશ્નોને પ્રશ્નપત્રમાં રૂપાંતરિત કરી શકાય છે અને PDF, CSV અથવા એક્સેલ ફોર્મેટમાં નિકાસ કરી શકાય છે',
  'homeBanner4': 'ફિલ્ટરેશન વિકલ્પો',
  'homeBanner4.2': 'વિવિધ પ્રશ્નોમાંથી પસંદ કરો',
  'homeBanner4.3': 'ક્યુરેટેડ પ્રશ્નોની સંપૂર્ણ યાદી મેળવવા માટે બોર્ડ, વર્ગ, મુશ્કેલી, ગુણ, પ્રશ્નોની સંખ્યા અને અન્ય પરિમાણોના આધારે પ્રશ્નો ફિલ્ટર કરો અને પસંદ કરો',
  'qbagDescp3': 'હમણાં તમારું એકાઉન્ટ બનાવો અને તમારા પેપર સેટર સહાયક તરીકે QBaG નો ઉપયોગ કરો.',
  'qbagDescp4': 'QBaG ની વધુ સુવિધાઓનું અન્વેષણ કરવા માટે, પ્રારંભ કરવા માટે એક એકાઉન્ટ બનાવો.',
  'footer': 'પર અમને અનુસરો',
  'register': 'નોંધણી કરો',
  'login': 'પ્રવેશ કરો',
  'name': 'અટક',
  'employment': 'રોજગાર',
  'dragNDropProof': "ડ્રેગ 'એન' છોડો અથવા માન્ય ઓળખ પુરાવો પસંદ કરો",
  'uploadPhotoID': 'ફોટો ID અપલોડ કરો',
  'email': 'ઈ - મેઈલ સરનામું',
  'userType': 'વપરાશકર્તા પ્રકાર',
  'teacherType': 'શિક્ષક',
  'othersType': 'અન્ય',
  'schoolCollege': 'શાળા/કોલેજ',
  'position': 'પદ',
  'education': 'શિક્ષણ',
  'password': 'પાસવર્ડ',
  'forgotPassword': 'પાસવર્ડ ભૂલી ગયા છો?',
  'dontHaveAnAccountSignUp': 'ખાતું નથી? સાઇન અપ કરો',
  'alreadyHaveAnAccountSignIn': 'પહેલેથી એકાઉન્ટ છે? સાઇન ઇન કરો',
  'addQuestion': 'પ્રશ્ન ઉમેરો',
  'searchQuestion': 'પ્રશ્ન શોધો',
  'generateQuestionPaper': 'પ્રશ્નપત્ર જનરેટ કરો',
  'viewPastPapers': 'જનરેટેડ પેપર્સ',
  'noQuestionsFound': 'માફ કરશો, કોઈ પ્રશ્નો મળ્યા નથી',
  'contributeQuestions': 'યોગદાન પ્રશ્નો',
  'myQuestions': 'મારા પ્રશ્નો',
  'myTemplates': 'મારા નમૂનાઓ',
  'questionDetails': 'પ્રશ્ન વિગતો',
  'board': 'પાટીયું',
  'langMedium': 'બોર્ડનું માધ્યમ',
  'grade': 'ગ્રીડ',
  'questionType': 'પ્રશ્નનો પ્રકાર',
  'mcq': 'બહુવિધ પસંદગીના પ્રશ્નો',
  'oneWord': 'એક શબ્દ અથવા વાક્ય',
  'fillInTheBlanks': 'ખાલી જગ્યા પૂરો',
  'matchTheFollowing': 'નીચેના સાથે મેળ કરો',
  'difficulty': 'મુશ્કેલી',
  'easy': 'સરળ',
  'medium': 'મધ્યમ',
  'hard': 'સખત',
  'mark': 'ચિહ્ન',
  'marks': 'ગુણ',
  'subject': 'વિષય',
  'typeKeywordsAndPressEnter': 'વિષયો લખો અને Enter દબાવો',
  'question': 'પ્રશ્ન',
  'questions': 'પ્રશ્નો',
  'numQuestions': 'પ્રશ્નોની સંખ્યા',
  'key': 'કી',
  'value': 'મૂલ્ય',
  'addNew': 'નવો ઉમેરો',
  'remove': 'દૂર કરો',
  'answer': 'જવાબ આપો',
  'answers': 'જવાબો',
  'columnA': 'કૉલમ એ',
  'columnB': 'કૉલમ B',
  'correctOption': 'સાચો વિકલ્પ',
  'wrongOpts': 'ખોટા વિકલ્પો',
  'wrongOption': 'ખોટા વિકલ્પો લખો અને એન્ટર દબાવો',
  'back': 'પાછળ',
  'next': 'આગળ',
  'enterQuestion': 'પ્રશ્ન દાખલ કરો',
  'addAnotherQuestion': 'બીજો પ્રશ્ન ઉમેરો',
  'enterQuestionSuccess': 'તમારા પ્રશ્ન બદલ આભાર.',
  'enterQuestionError': 'અરે! એક સમાન પ્રશ્ન પહેલેથી અસ્તિત્વમાં છે!',
  'search': 'શોધો',
  'exportPDF': 'પીડીએફમાં પ્રિન્ટ કરો',
  'reviewQuestion': 'પ્રશ્નની સમીક્ષા કરો',
  'submitQuestion': 'પ્રશ્ન સબમિટ કરો',
  'invalidRegistration': 'અમાન્ય નોંધણી ડેટા! મહેરબાની કરીને ફરીથી પ્રયતન કરો',
  'verifyEmail': 'આપેલ ઈમેલ એડ્રેસ પર ઈમેલ વેરિફિકેશન લિંક મોકલવામાં આવી છે.\nએકાઉન્ટ સેટઅપ પૂર્ણ કરવા માટે કૃપા કરીને તમારી ઇમેઇલ ચકાસો.\nચકાસણી લિંક 24 કલાક માટે માન્ય છે',
  'loginError1': 'અમાન્ય લૉગિન ઓળખપત્રો! મહેરબાની કરીને ફરીથી પ્રયતન કરો',
  'loginError2': 'કૃપા કરીને તમારા ઇમેઇલને માન્ય કરો! તમારું ઇનબોક્સ તપાસો',
  'dashboard': 'ડેશબોર્ડ',
  'viewIDProof': 'ID પ્રૂફ જુઓ',
  'changePassword': 'પાસવર્ડ બદલો',
  'changePasswordError': 'જૂનો પાસવર્ડ ખોટો છે. મહેરબાની કરીને ફરીથી પ્રયતન કરો',
  'oldPassword': 'જુનો પાસવર્ડ',
  'newPassword': 'નવો પાસવર્ડ',
  'confirmNewPassword': 'નવાપાસવર્ડની પુષ્ટી કરો',
  'logout': 'લૉગ આઉટ',
  'ok': 'બરાબર',
  'submit': 'સબમિટ કરો',
  'change': 'બદલો',
  'backToHome': 'ઘરે પાછા',
  'pageNotFound': 'પેજ નથી મળ્યું',
  'getResetLink': 'તમારો પાસવર્ડ રીસેટ લિંક મેળવવા માટે ઈમેલ દાખલ કરો',
  'enterNewPassword': 'તમારો નવો પાસવર્ડ દાખલ કરો',
  'resetPasswordAlertTitle': 'પાસવર્ડ સફળતાપૂર્વક બદલાયો',
  'resetPasswordAlertDescription': 'તમારો પાસવર્ડ સફળતાપૂર્વક રીસેટ કરવામાં આવ્યો છે.\nકૃપા કરીને લૉગિન કરવા માટે આગળ વધો',
  'resetPasswordError': 'રીસેટ લિંકની સમયસીમા સમાપ્ત થઈ ગઈ છે! મહેરબાની કરીને ફરીથી પ્રયતન કરો',
  'forgotPasswordError': 'અમાન્ય ઇમેઇલ ID! મહેરબાની કરીને ફરીથી પ્રયતન કરો',
  'forgotPasswordAlertTitle': 'પાસવર્ડ લિંક રીસેટ કરો',
  'forgotPasswordAlertDescription': 'આપેલ ઈમેલ એડ્રેસ પર રીસેટ પાસવર્ડ લિંક મોકલવામાં આવી છે.\nતમારો નવો પાસવર્ડ સેટ કરવા માટે કૃપા કરીને લિંક પર ક્લિક કરો.\nરીસેટ લિંક 24 કલાક માટે માન્ય છે',
  'selectQuestions': 'પ્રશ્નો પસંદ કરો',
  'selectedQuestions': 'પ્રશ્નો પસંદ કર્યા',
  'reviewQuestions': 'પ્રશ્નોની સમીક્ષા કરો',
  'generatePaper': 'પેપર જનરેટ કરો',
  'savePaper': 'પેપર સાચવો',
  'easyQuestions': 'સરળ પ્રશ્નોની સંખ્યા',
  'mediumQuestions': 'મધ્યમ પ્રશ્નોની સંખ્યા',
  'hardQuestions': 'સખત પ્રશ્નોની સંખ્યા',
  'totalQuestions': 'પ્રશ્નોની કુલ સંખ્યા',
  'totalMarks': 'કુલ ગુણ',
  'mcqs': 'બહુવિધ પસંદગીના પ્રશ્નોની સંખ્યા',
  'oneWords': 'એક શબ્દ/વાક્યના પ્રશ્નોની સંખ્યા',
  'fillInTheBlankss': 'નંબર. ખાલી પ્રશ્નો ભરો',
  'matchTheFollowings': 'નંબર. નીચેના પ્રશ્નો સાથે મેળ કરો',
  'paperName': 'કાગળનું નામ',
  'vettedWarning': 'નીચેના પ્રશ્નો સમુદાય દ્વારા ચકાસાયેલ નથી, શું તમે હજુ પણ ચાલુ રાખવા માંગો છો?',
  'requested': 'વિનંતી કરી',
  'selected': 'પસંદ કરેલ',
  'noPapersGenerated': 'હજુ સુધી કોઈ પ્રશ્નપત્રો જનરેટ થયા નથી',
  'noTemplatesSaved': 'તમે કોઈપણ નમૂનાઓ સાચવ્યા નથી',
  'savePrompt': 'આ શોધને નમૂના તરીકે સાચવો',
  'save': 'સવા',
  'downvoteModalHead': 'ડાઉનવોટ માટેનું કારણ',
  'downvoteModalSubHead': 'કૃપા કરીને પ્રશ્નને ડાઉનવોટ કરવા માટેનું કારણ આપો',
  'cancel': 'રદ કરો',
  'noSpeechSupport': 'બ્રાઉઝર વાણી ઓળખને સપોર્ટ કરતું નથી',
  'uploadCSV': 'CSV ફાઇલ અપલોડ કરો',
  'submitFile': 'ફાઇલો સબમિટ કરો',
  'downloadSample': 'સેમ્પલ ડાઉનલોડ કરો',
        'sorryNote': 'અમે દિલગીર છીએ! આ પેપર માટે કોઈ પ્રશ્નો મળ્યા નથી. તેમને સમુદાય દ્વારા અમાન્ય તરીકે ચિહ્નિત કરવામાં આવ્યા હોઈ શકે છે અને તેથી અમારા સર્વરમાંથી કાઢી નાખવામાં આવ્યા છે.',
    'extraQuestions': 'વધારાના પ્રશ્નોના %'
    },
 'मराठी': {'language': 'भाषा बदला',
  'qbag': 'प्रश्न बँक जनरेटर',
  'qbagDescp1': 'प्रश्न बँक जनरेटर वस्तुनिष्ठ प्रश्नांच्या मोठ्या समूहातून प्रश्न बँक तयार करण्यासाठी क्राउड सोर्सिंग मॉडेल वापरतो. QBaG आमच्या स्वयंचलित आणि मजबूत प्रणालीचा वापर करून विश्वासार्ह प्रश्नपत्रिका तयार करण्यासाठी पेपर सेटर आणि शिक्षणतज्ज्ञांसाठी इंटरफेस प्रदान करते. प्रश्न विविध पॅरामीटर्सच्या आधारे निवडले जाऊ शकतात आणि काही मिनिटांत आपल्या इच्छित स्वरूपात निर्यात केले जाऊ शकतात. योगदान दिलेला प्रत्येक प्रश्न अनेक तपासण्यांमधून जातो आणि तज्ञांद्वारे तपासला जातो.',
  'qbagDescp2': 'हे अॅप टीम-एक्झिक्युटेबल्सने तयार केले आहे',
  'homeBanner1': 'क्राउडसोर्स केलेले प्रश्न',
  'homeBanner1.2': 'विविध स्त्रोतांकडून प्रश्न मिळवा',
  'homeBanner1.3': 'क्राउडसोर्सिंग सर्व वापरकर्त्यांना योगदान देण्यास सक्षम करते, हे एकाधिक दृष्टिकोन एकत्रित करण्यात मदत करते आणि प्रश्नांच्या संग्रहामध्ये विविधता आणते. क्राउडसोर्सिंगमुळे व्यवस्थापनाचा भार कमी होतो कारण मुख्य काम प्रणालीद्वारे हाताळले जाते जे वापरकर्त्याला मॅन्युअल कामापासून मुक्त करते',
  'homeBanner2': 'विश्वसनीय प्रश्न',
  'homeBanner2.2': 'सत्यापित आणि प्रमाणित प्रश्न',
  'homeBanner2.3': 'योगदान दिलेला प्रत्येक प्रश्न स्वयंचलित चाचणीच्या मालिकेतून जातो, ज्याची नंतर तज्ञांकडून छाननी केली जाते',
  'homeBanner3': 'निर्यात करा',
  'homeBanner3.2': 'इच्छित स्वरूपात प्रश्न निर्यात करा',
  'homeBanner3.3': 'निवडलेले प्रश्न प्रश्नपत्रिकेत रूपांतरित केले जाऊ शकतात आणि PDF, CSV किंवा एक्सेल स्वरूपात निर्यात केले जाऊ शकतात',
  'homeBanner4': 'फिल्टरेशन पर्याय',
  'homeBanner4.2': 'विविध प्रश्नांमधून निवडा',
  'homeBanner4.3': 'निवडलेल्या प्रश्नांची परिपूर्ण यादी मिळविण्यासाठी बोर्ड, वर्ग, अडचण, गुण, प्रश्नांची संख्या आणि इतर पॅरामीटर्सवर आधारित प्रश्न फिल्टर करा आणि निवडा',
  'qbagDescp3': 'आता तुमचे खाते तयार करा आणि तुमचा पेपर सेटर सहाय्यक म्हणून QBaG वापरा.',
  'qbagDescp4': 'QBaG ची अधिक वैशिष्ट्ये एक्सप्लोर करण्यासाठी, प्रारंभ करण्यासाठी खाते तयार करा.',
  'footer': 'आमचे अनुसरण करा',
  'register': 'नोंदणी करा',
  'login': 'लॉगिन करा',
  'name': 'आडनाव',
  'employment': 'रोजगार',
  'dragNDropProof': "ड्रॅग 'एन' ड्रॉप करा किंवा वैध ओळख पुरावा निवडा",
  'uploadPhotoID': 'फोटो आयडी अपलोड करा',
  'email': 'ईमेल पत्ता',
  'userType': 'वापरकर्ता प्रकार',
  'teacherType': 'शिक्षक',
  'othersType': 'इतर',
  'schoolCollege': 'शाळा/कॉलेज',
  'position': 'स्थिती',
  'education': 'शिक्षण',
  'password': 'पासवर्ड',
  'forgotPassword': 'पासवर्ड विसरलात?',
  'dontHaveAnAccountSignUp': 'खाते नाही? साइन अप करा',
  'alreadyHaveAnAccountSignIn': 'आधीपासूनच एक खाते आहे? साइन इन करा',
  'addQuestion': 'प्रश्न जोडा',
  'searchQuestion': 'शोध प्रश्न',
  'generateQuestionPaper': 'प्रश्नपत्रिका तयार करा',
  'viewPastPapers': 'व्युत्पन्न कागदपत्रे',
  'noQuestionsFound': 'क्षमस्व, कोणतेही प्रश्न आढळले नाहीत',
  'contributeQuestions': 'योगदान प्रश्न',
  'myQuestions': 'माझे प्रश्न',
  'myTemplates': 'माझे टेम्पलेट्स',
  'questionDetails': 'प्रश्न तपशील',
  'board': 'बोर्ड',
  'langMedium': 'मंडळाचे माध्यम',
  'grade': 'ग्रिड',
  'questionType': 'प्रश्न प्रकार',
  'mcq': 'एकाधिक निवड प्रश्न',
  'oneWord': 'एक शब्द किंवा वाक्य',
  'fillInTheBlanks': 'रिक्त स्थानांची पुरती करा',
  'matchTheFollowing': 'खालील जुळवा',
  'difficulty': 'अडचण',
  'easy': 'सोपे',
  'medium': 'मध्यम',
  'hard': 'कठीण',
  'mark': 'खूण करा',
  'marks': 'मार्क्स',
  'subject': 'विषय',
  'typeKeywordsAndPressEnter': 'विषय टाइप करा आणि एंटर दाबा',
  'question': 'प्रश्न',
  'questions': 'प्रश्न',
  'numQuestions': 'प्रश्नांची संख्या',
  'key': 'की',
  'value': 'मूल्य',
  'addNew': 'नवीन जोडा',
  'remove': 'काढा',
  'answer': 'उत्तर द्या',
  'answers': 'उत्तरे',
  'columnA': 'स्तंभ ए',
  'columnB': 'स्तंभ बी',
  'correctOption': 'योग्य पर्याय',
  'wrongOpts': 'चुकीचे पर्याय',
  'wrongOption': 'चुकीचे पर्याय टाइप करा आणि एंटर दाबा',
  'back': 'मागे',
  'next': 'पुढे',
  'enterQuestion': 'प्रश्न प्रविष्ट करा',
  'addAnotherQuestion': 'दुसरा प्रश्न जोडा',
  'enterQuestionSuccess': 'तुमच्या प्रश्नाबद्दल धन्यवाद.',
  'enterQuestionError': 'अरेरे! एक समान प्रश्न आधीच अस्तित्वात आहे!',
  'search': 'शोधा',
  'exportPDF': 'PDF वर प्रिंट करा',
  'reviewQuestion': 'प्रश्नाचे पुनरावलोकन करा',
  'submitQuestion': 'प्रश्न सबमिट करा',
  'invalidRegistration': 'अवैध नोंदणी डेटा! कृपया पुन्हा प्रयत्न करा',
  'verifyEmail': 'दिलेल्या ईमेल पत्त्यावर ईमेल पडताळणी लिंक पाठवली आहे.\nखाते सेटअप पूर्ण करण्यासाठी कृपया तुमचा ईमेल सत्यापित करा.\nपडताळणी लिंक २४ तासांसाठी वैध आहे',
  'loginError1': 'अवैध लॉगिन क्रेडेन्शियल! कृपया पुन्हा प्रयत्न करा',
  'loginError2': 'कृपया तुमचा ईमेल सत्यापित करा! आपला इनबॉक्स तपासा',
  'dashboard': 'डॅशबोर्ड',
  'viewIDProof': 'आयडी प्रूफ पहा',
  'changePassword': 'पासवर्ड बदला',
  'changePasswordError': 'जुना पासवर्ड चुकीचा आहे. कृपया पुन्हा प्रयत्न करा',
  'oldPassword': 'जुना पासवर्ड',
  'newPassword': 'नवीन पासवर्ड',
  'confirmNewPassword': 'नवीन परवलीच्या शब्दाची खात्री करा',
  'logout': 'बाहेर पडणे',
  'ok': 'ठीक आहे',
  'submit': 'प्रस्तुत करणे',
  'change': 'बदला',
  'backToHome': 'परत घराच्या दिशेने',
  'pageNotFound': 'पृष्ठ सापडले नाही',
  'getResetLink': 'तुमचा पासवर्ड रिसेट लिंक मिळवण्यासाठी ईमेल एंटर करा',
  'enterNewPassword': 'तुमचा नवीन पासवर्ड टाका',
  'resetPasswordAlertTitle': 'पासवर्ड यशस्वीरित्या बदलला',
  'resetPasswordAlertDescription': 'तुमचा पासवर्ड यशस्वीरित्या रीसेट केला गेला आहे.\nकृपया लॉग इन करण्यासाठी पुढे जा',
  'resetPasswordError': 'रीसेट लिंक कालबाह्य झाली आहे! कृपया पुन्हा प्रयत्न करा',
  'forgotPasswordError': 'अवैध ईमेल आयडी! कृपया पुन्हा प्रयत्न करा',
  'forgotPasswordAlertTitle': 'पासवर्ड लिंक रीसेट करा',
  'forgotPasswordAlertDescription': 'दिलेल्या ईमेल पत्त्यावर पासवर्ड रीसेट करण्याची लिंक पाठवली आहे.\nतुमचा नवीन पासवर्ड सेट करण्यासाठी कृपया लिंकवर क्लिक करा.\nरीसेट लिंक 24 तासांसाठी वैध आहे',
  'selectQuestions': 'प्रश्न निवडा',
  'selectedQuestions': 'प्रश्न निवडले',
  'reviewQuestions': 'प्रश्नांचे पुनरावलोकन करा',
  'generatePaper': 'पेपर तयार करा',
  'savePaper': 'कागद जतन करा',
  'easyQuestions': 'सोप्या प्रश्नांची संख्या',
  'mediumQuestions': 'मध्यम प्रश्नांची संख्या',
  'hardQuestions': 'कठीण प्रश्नांची संख्या',
  'totalQuestions': 'एकूण प्रश्नांची संख्या',
  'totalMarks': 'एकूण गुण',
  'mcqs': 'एकाधिक निवड प्रश्नांची संख्या',
  'oneWords': 'एक शब्द/वाक्य प्रश्नांची संख्या',
  'fillInTheBlankss': 'क्र. रिक्त प्रश्न भरा',
  'matchTheFollowings': 'क्र. खालील प्रश्न जुळवा',
  'paperName': 'कागदाचे नाव',
  'vettedWarning': 'खालील प्रश्नांची समुदायाद्वारे तपासणी केली जात नाही, तरीही तुम्ही सुरू ठेवू इच्छिता?',
  'requested': 'विनंती केली',
  'selected': 'निवडले',
  'noPapersGenerated': 'अद्याप कोणतीही प्रश्नपत्रिका तयार झालेली नाही',
  'noTemplatesSaved': 'तुम्ही कोणतेही टेम्पलेट सेव्ह केलेले नाहीत',
  'savePrompt': 'हा शोध टेम्पलेट म्हणून जतन करा',
  'save': 'सावा',
  'downvoteModalHead': 'Downvote साठी कारण',
  'downvoteModalSubHead': 'कृपया प्रश्न नाकारण्याचे कारण प्रदान करा',
  'cancel': 'रद्द करा',
  'noSpeechSupport': 'ब्राउझर स्पीच रेकग्निशनला सपोर्ट करत नाही',
  'uploadCSV': 'CSV फाइल अपलोड करा',
  'submitFile': 'फाइल्स सबमिट करा',
  'downloadSample': 'नमुना डाउनलोड करा',
        'sorryNote': 'आम्ही क्षमस्व आहोत! या पेपरसाठी कोणतेही प्रश्न आढळले नाहीत. ते कदाचित समुदायाद्वारे अवैध म्हणून चिन्हांकित केले गेले असतील आणि म्हणून आमच्या सर्व्हरवरून हटवले गेले असतील.',
    'extraQuestions': 'अतिरिक्त प्रश्नांचा %'},
 'বাংলা': {'language': 'ভাষা পরিবর্তন করুন',
  'qbag': 'প্রশ্ন ব্যাংক জেনারেটর',
  'qbagDescp1': 'প্রশ্নব্যাংক জেনারেটর একটি ক্রাউড সোর্সিং মডেল ব্যবহার করে উদ্দেশ্যমূলক প্রশ্নের একটি বড় পুল থেকে প্রশ্নব্যাঙ্ক তৈরি করতে। QBaG আমাদের স্বয়ংক্রিয় এবং শক্তিশালী সিস্টেম ব্যবহার করে নির্ভরযোগ্য প্রশ্নপত্র তৈরি করতে পেপার সেটার এবং শিক্ষাবিদদের জন্য একটি ইন্টারফেস প্রদান করে। প্রশ্নগুলি বিভিন্ন প্যারামিটারের উপর ভিত্তি করে নির্বাচন করা যেতে পারে এবং কয়েক মিনিটের মধ্যে আপনার পছন্দসই বিন্যাসে রপ্তানি করা যেতে পারে। অবদান রাখা প্রতিটি প্রশ্ন বেশ কয়েকটি চেকের মাধ্যমে পাস করা হয় এবং বিশেষজ্ঞদের দ্বারা যাচাই করা হয়।',
  'qbagDescp2': 'এই অ্যাপটি টিম-এক্সিকিউটেবল দ্বারা নির্মিত',
  'homeBanner1': 'ক্রাউডসোর্সড প্রশ্ন',
  'homeBanner1.2': 'বিভিন্ন উৎস থেকে প্রশ্ন পান',
  'homeBanner1.3': 'ক্রাউডসোর্সিং সমস্ত ব্যবহারকারীদের অবদান রাখতে সক্ষম করে, এটি একাধিক দৃষ্টিভঙ্গি সংগ্রহ করতে সহায়তা করে এবং প্রশ্নগুলির সংরক্ষণাগারকে বৈচিত্র্যময় করে। ক্রাউডসোর্সিং ব্যবস্থাপনার বোঝা হ্রাস করে কারণ প্রধান কাজটি সিস্টেম দ্বারা পরিচালিত হয় যা ব্যবহারকারীকে ম্যানুয়াল কাজ থেকে মুক্ত করে',
  'homeBanner2': 'নির্ভরযোগ্য প্রশ্ন',
  'homeBanner2.2': 'যাচাই এবং বৈধ প্রশ্ন',
  'homeBanner2.3': 'অবদান রাখা প্রতিটি প্রশ্ন স্বয়ংক্রিয় পরীক্ষার একটি সিরিজের মধ্য দিয়ে যায়, যা তারপর বিশেষজ্ঞদের দ্বারা যাচাই করা হয়',
  'homeBanner3': 'রপ্তানি',
  'homeBanner3.2': 'পছন্দসই বিন্যাসে প্রশ্ন রপ্তানি করুন',
  'homeBanner3.3': 'নির্বাচিত প্রশ্নগুলি একটি প্রশ্নপত্রে রূপান্তরিত করা যেতে পারে এবং PDF, CSV বা এক্সেল ফর্ম্যাটে রপ্তানি করা যেতে পারে',
  'homeBanner4': 'ফিল্টার অপশন',
  'homeBanner4.2': 'বিভিন্ন প্রশ্ন থেকে বেছে নিন',
  'homeBanner4.3': 'কিউরেট করা প্রশ্নের নিখুঁত তালিকা পেতে বোর্ড, ক্লাস, অসুবিধা, মার্কস, প্রশ্নের সংখ্যা এবং অন্যান্য প্যারামিটারের উপর ভিত্তি করে প্রশ্নগুলি ফিল্টার করুন এবং চয়ন করুন',
  'qbagDescp3': 'এখন আপনার অ্যাকাউন্ট তৈরি করুন, এবং আপনার পেপার সেটার সহকারী হিসাবে QBaG ব্যবহার করুন।',
  'qbagDescp4': 'QBaG-এর আরও বৈশিষ্ট্যগুলি অন্বেষণ করতে, শুরু করতে একটি অ্যাকাউন্ট তৈরি করুন৷',
  'footer': 'আমাদেরকে অনুসরণ করুন',
  'register': 'নিবন্ধন',
  'login': 'প্রবেশ করুন',
  'name': 'পদবি',
  'employment': 'কর্মসংস্থান',
  'dragNDropProof': 'টেনে আনুন ড্রপ বা একটি বৈধ পরিচয় প্রমাণ নির্বাচন করুন',
  'uploadPhotoID': 'ফটো আইডি আপলোড করুন',
  'email': 'ইমেইল ঠিকানা',
  'userType': 'ব্যবহারকারীর ধরন',
  'teacherType': 'শিক্ষক',
  'othersType': 'অন্যান্য',
  'schoolCollege': 'স্কুল/কলেজ',
  'position': 'অবস্থান',
  'education': 'শিক্ষা',
  'password': 'পাসওয়ার্ড',
  'forgotPassword': 'পাসওয়ার্ড ভুলে গেছেন?',
  'dontHaveAnAccountSignUp': 'একটি অ্যাকাউন্ট নেই? নিবন্ধন করুন',
  'alreadyHaveAnAccountSignIn': 'ইতিমধ্যে একটি সদস্যপদ আছে? সাইন ইন করুন',
  'addQuestion': 'প্রশ্ন যোগ করুন',
  'searchQuestion': 'অনুসন্ধান প্রশ্ন',
  'generateQuestionPaper': 'প্রশ্নপত্র তৈরি করুন',
  'viewPastPapers': 'তৈরি কাগজপত্র',
  'noQuestionsFound': 'দুঃখিত, কোন প্রশ্ন পাওয়া যায়নি',
  'contributeQuestions': 'অবদান প্রশ্ন',
  'myQuestions': 'আমার প্রশ্নগুলো',
  'myTemplates': 'আমার টেমপ্লেট',
  'questionDetails': 'প্রশ্ন বিবরণ',
  'board': 'বোর্ড',
  'langMedium': 'বোর্ডের মাধ্যম',
  'grade': 'গ্রিড',
  'questionType': 'প্রশ্নের ধরন',
  'mcq': 'বহু নির্বাচনী প্রশ্ন',
  'oneWord': 'একটি শব্দ বা বাক্য',
  'fillInTheBlanks': 'শুন্যস্তান পূরণ',
  'matchTheFollowing': 'নিচের সাথে মেলাও',
  'difficulty': 'অসুবিধা',
  'easy': 'সহজ',
  'medium': 'মধ্যম',
  'hard': 'কঠিন',
  'mark': 'মার্ক',
  'marks': 'চিহ্ন',
  'subject': 'বিষয়',
  'typeKeywordsAndPressEnter': 'বিষয় টাইপ করুন এবং এন্টার টিপুন',
  'question': 'প্রশ্ন',
  'questions': 'প্রশ্ন',
  'numQuestions': 'প্রশ্নের সংখ্যা',
  'key': 'চাবি',
  'value': 'মান',
  'addNew': 'নতুন যোগ করুন',
  'remove': 'অপসারণ',
  'answer': 'উত্তর',
  'answers': 'উত্তর',
  'columnA': 'কলাম এ',
  'columnB': 'কলাম বি',
  'correctOption': 'সঠিক বিকল্প',
  'wrongOpts': 'ভুল বিকল্প',
  'wrongOption': 'ভুল বিকল্প টাইপ করুন এবং এন্টার টিপুন',
  'back': 'পেছনে',
  'next': 'পরবর্তী',
  'enterQuestion': 'প্রশ্ন লিখুন',
  'addAnotherQuestion': 'আরেকটি প্রশ্ন যোগ করুন',
  'enterQuestionSuccess': 'আপনার প্রশ্নের জন্য ধন্যবাদ.',
  'enterQuestionError': 'ওহো! একটি অনুরূপ প্রশ্ন ইতিমধ্যে বিদ্যমান!',
  'search': 'অনুসন্ধান করুন',
  'exportPDF': 'PDF এ প্রিন্ট করুন',
  'reviewQuestion': 'প্রশ্ন পর্যালোচনা করুন',
  'submitQuestion': 'প্রশ্ন জমা দিন',
  'invalidRegistration': 'অবৈধ নিবন্ধন তথ্য! অনুগ্রহপূর্বক আবার চেষ্টা করুন',
  'verifyEmail': 'প্রদত্ত ইমেল ঠিকানায় একটি ইমেল যাচাইকরণ লিঙ্ক পাঠানো হয়েছে।\nঅ্যাকাউন্ট সেটআপ সম্পূর্ণ করতে আপনার ইমেল যাচাই করুন.\nযাচাইকরণ লিঙ্ক 24 ঘন্টার জন্য বৈধ',
  'loginError1': 'অবৈধ লগইন শংসাপত্রের! অনুগ্রহপূর্বক আবার চেষ্টা করুন',
  'loginError2': 'আপনার ইমেল যাচাই করুন! আপনার ইনবক্স চেক করুন',
  'dashboard': 'ড্যাশবোর্ড',
  'viewIDProof': 'আইডি প্রুফ দেখুন',
  'changePassword': 'পাসওয়ার্ড পরিবর্তন করুন',
  'changePasswordError': 'পুরানো পাসওয়ার্ড ভুল। অনুগ্রহপূর্বক আবার চেষ্টা করুন',
  'oldPassword': 'পুরানো পাসওয়ার্ড',
  'newPassword': 'নতুন পাসওয়ার্ড',
  'confirmNewPassword': 'নিশ্চিত কর নতুন গোপননম্বর',
  'logout': 'প্রস্থান',
  'ok': 'ঠিক আছে',
  'submit': 'জমা দিন',
  'change': 'পরিবর্তন',
  'backToHome': 'বাড়িতে ফিরে যাও',
  'pageNotFound': 'পৃষ্ঠা খুঁজে পাওয়া যায়নি',
  'getResetLink': 'আপনার পাসওয়ার্ড রিসেট লিঙ্ক পেতে ইমেল লিখুন',
  'enterNewPassword': 'আপনার নতুন পাসওয়ার্ড লিখুন',
  'resetPasswordAlertTitle': 'পাসওয়ার্ড সফলভাবে পরিবর্তন',
  'resetPasswordAlertDescription': 'আপনার পাসওয়ার্ড সফলভাবে পুনরায় সেট করা হয়েছে.\nলগইন করতে এগিয়ে যান',
  'resetPasswordError': 'রিসেট লিঙ্কের মেয়াদ শেষ হয়েছে! অনুগ্রহপূর্বক আবার চেষ্টা করুন',
  'forgotPasswordError': 'অবৈধ ইমেইল আইডি! অনুগ্রহপূর্বক আবার চেষ্টা করুন',
  'forgotPasswordAlertTitle': 'পাসওয়ার্ড লিঙ্ক রিসেট করুন',
  'forgotPasswordAlertDescription': 'প্রদত্ত ইমেল ঠিকানায় একটি রিসেট পাসওয়ার্ড লিঙ্ক পাঠানো হয়েছে।\nআপনার নতুন পাসওয়ার্ড সেট করতে লিঙ্কে ক্লিক করুন.\nরিসেট লিঙ্ক 24 ঘন্টার জন্য বৈধ',
  'selectQuestions': 'প্রশ্ন নির্বাচন করুন',
  'selectedQuestions': 'নির্বাচিত প্রশ্ন',
  'reviewQuestions': 'পর্যালোচনা প্রশ্ন',
  'generatePaper': 'কাগজ তৈরি করুন',
  'savePaper': 'কাগজ সংরক্ষণ করুন',
  'easyQuestions': 'সহজ প্রশ্নের সংখ্যা',
  'mediumQuestions': 'মাঝারি প্রশ্নের সংখ্যা',
  'hardQuestions': 'কঠিন প্রশ্নের সংখ্যা',
  'totalQuestions': 'মোট প্রশ্নের সংখ্যা',
  'totalMarks': 'মোট মার্কস',
  'mcqs': 'একাধিক পছন্দের প্রশ্নের সংখ্যা',
  'oneWords': 'এক শব্দ/বাক্য প্রশ্নের সংখ্যা',
  'fillInTheBlankss': 'না। ফাঁকা প্রশ্ন পূরণ করুন',
  'matchTheFollowings': 'নিচের প্রশ্নগুলোর সাথে মিল করুন',
  'paperName': 'কাগজের নাম',
  'vettedWarning': 'নিম্নলিখিত প্রশ্নগুলি সম্প্রদায় দ্বারা যাচাই করা হয় না, আপনি কি এখনও চালিয়ে যেতে চান?',
  'requested': 'অনুরোধ',
  'selected': 'নির্বাচিত',
  'noPapersGenerated': 'কোন প্রশ্নপত্র এখনো তৈরি হয় না',
  'noTemplatesSaved': 'আপনি কোনো টেমপ্লেট সংরক্ষণ করেননি',
  'savePrompt': 'একটি টেমপ্লেট হিসাবে এই অনুসন্ধান সংরক্ষণ করুন',
  'save': 'সাভা',
  'downvoteModalHead': 'ডাউনভোটের কারণ',
  'downvoteModalSubHead': 'প্রশ্ন ডাউনভোট করার জন্য একটি কারণ প্রদান করুন',
  'cancel': 'বাতিল করুন',
  'noSpeechSupport': 'ব্রাউজার স্পিচ রিকগনিশন সমর্থন করে না',
  'uploadCSV': 'CSV ফাইল আপলোড করুন',
  'submitFile': 'ফাইল জমা দিন',
  'downloadSample': 'নমুনা ডাউনলোড করুন',
  'sorryNote': 'আমরা দুঃখিত! এই কাগজের জন্য কোন প্রশ্ন পাওয়া যায়নি. সেগুলি সম্প্রদায়ের দ্বারা অবৈধ হিসাবে চিহ্নিত হতে পারে এবং তাই আমাদের সার্ভার থেকে মুছে ফেলা হয়েছে৷','extraQuestions': 'অতিরিক্ত প্রশ্নের %'},
 'ಕನ್ನಡ': {'language': 'ಭಾಷೆ ಬದಲಾಯಿಸಿ',
  'qbag': 'ಪ್ರಶ್ನೆ ಬ್ಯಾಂಕ್ ಜನರೇಟರ್',
  'qbagDescp1': 'ಪ್ರಶ್ನೆ ಬ್ಯಾಂಕ್ ಜನರೇಟರ್ ವಸ್ತುನಿಷ್ಠ ಪ್ರಶ್ನೆಗಳ ದೊಡ್ಡ ಪೂಲ್\u200cನಿಂದ ಪ್ರಶ್ನೆ ಬ್ಯಾಂಕ್\u200cಗಳನ್ನು ತಯಾರಿಸಲು ಕ್ರೌಡ್ ಸೋರ್ಸಿಂಗ್ ಮಾದರಿಯನ್ನು ಬಳಸುತ್ತದೆ. QBaG ನಮ್ಮ ಸ್ವಯಂಚಾಲಿತ ಮತ್ತು ದೃಢವಾದ ವ್ಯವಸ್ಥೆಯನ್ನು ಬಳಸಿಕೊಂಡು ವಿಶ್ವಾಸಾರ್ಹ ಪ್ರಶ್ನೆ ಪತ್ರಿಕೆಗಳನ್ನು ರಚಿಸಲು ಪೇಪರ್ ಸೆಟ್ಟರ್\u200cಗಳು ಮತ್ತು ಶಿಕ್ಷಣತಜ್ಞರಿಗೆ ಇಂಟರ್ಫೇಸ್ ಅನ್ನು ಒದಗಿಸುತ್ತದೆ. ಪ್ರಶ್ನೆಗಳನ್ನು ಪ್ಯಾರಾಮೀಟರ್\u200cಗಳ ಶ್ರೇಣಿಯ ಆಧಾರದ ಮೇಲೆ ಆಯ್ಕೆ ಮಾಡಬಹುದು ಮತ್ತು ನಿಮಿಷಗಳಲ್ಲಿ ನೀವು ಬಯಸಿದ ಸ್ವರೂಪಕ್ಕೆ ರಫ್ತು ಮಾಡಬಹುದು. ಕೊಡುಗೆ ನೀಡಿದ ಪ್ರತಿಯೊಂದು ಪ್ರಶ್ನೆಯನ್ನು ಹಲವಾರು ಚೆಕ್\u200cಗಳ ಮೂಲಕ ರವಾನಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಪರಿಣಿತರಿಂದ ಪರಿಶೀಲಿಸಲಾಗುತ್ತದೆ.',
  'qbagDescp2': 'ಈ ಅಪ್ಲಿಕೇಶನ್ ಅನ್ನು ತಂಡ-ಕಾರ್ಯನಿರ್ವಾಹಕರು ನಿರ್ಮಿಸಿದ್ದಾರೆ',
  'homeBanner1': 'ಕ್ರೌಡ್ಸೋರ್ಸ್ಡ್ ಪ್ರಶ್ನೆಗಳು',
  'homeBanner1.2': 'ವಿವಿಧ ಮೂಲಗಳಿಂದ ಪ್ರಶ್ನೆಗಳನ್ನು ಪಡೆಯಿರಿ',
  'homeBanner1.3': 'ಕ್ರೌಡ್\u200cಸೋರ್ಸಿಂಗ್ ಎಲ್ಲಾ ಬಳಕೆದಾರರಿಗೆ ಕೊಡುಗೆ ನೀಡಲು ಶಕ್ತಗೊಳಿಸುತ್ತದೆ, ಇದು ಬಹು ದೃಷ್ಟಿಕೋನಗಳನ್ನು ಸಂಗ್ರಹಿಸಲು ಸಹಾಯ ಮಾಡುತ್ತದೆ ಮತ್ತು ಪ್ರಶ್ನೆಗಳ ಆರ್ಕೈವ್ ಅನ್ನು ವೈವಿಧ್ಯಗೊಳಿಸುತ್ತದೆ. ಕ್ರೌಡ್\u200cಸೋರ್ಸಿಂಗ್ ನಿರ್ವಹಣೆಯ ಹೊರೆಯನ್ನು ಕಡಿಮೆ ಮಾಡುತ್ತದೆ ಏಕೆಂದರೆ ಪ್ರಮುಖ ಕೆಲಸವನ್ನು ನಿರ್ವಹಿಸುವ ವ್ಯವಸ್ಥೆಯು ಬಳಕೆದಾರರನ್ನು ಹಸ್ತಚಾಲಿತ ಕೆಲಸದಿಂದ ಮುಕ್ತಗೊಳಿಸುತ್ತದೆ',
  'homeBanner2': 'ವಿಶ್ವಾಸಾರ್ಹ ಪ್ರಶ್ನೆಗಳು',
  'homeBanner2.2': 'ಪರಿಶೀಲಿಸಿದ ಮತ್ತು ಮೌಲ್ಯೀಕರಿಸಿದ ಪ್ರಶ್ನೆಗಳು',
  'homeBanner2.3': 'ಕೊಡುಗೆ ನೀಡಿದ ಪ್ರತಿಯೊಂದು ಪ್ರಶ್ನೆಯು ಸ್ವಯಂಚಾಲಿತ ಪರೀಕ್ಷೆಯ ಸರಣಿಯ ಮೂಲಕ ಹಾದುಹೋಗುತ್ತದೆ, ನಂತರ ಅದನ್ನು ತಜ್ಞರು ಪರಿಶೀಲಿಸುತ್ತಾರೆ',
  'homeBanner3': 'ರಫ್ತು',
  'homeBanner3.2': 'ಪ್ರಶ್ನೆಗಳನ್ನು ಬಯಸಿದ ಸ್ವರೂಪದಲ್ಲಿ ರಫ್ತು ಮಾಡಿ',
  'homeBanner3.3': 'ಆಯ್ದ ಪ್ರಶ್ನೆಗಳನ್ನು ಪ್ರಶ್ನೆ ಪತ್ರಿಕೆಯಾಗಿ ಪರಿವರ್ತಿಸಬಹುದು ಮತ್ತು PDF, CSV ಅಥವಾ ಎಕ್ಸೆಲ್ ಫಾರ್ಮ್ಯಾಟ್\u200cಗೆ ರಫ್ತು ಮಾಡಬಹುದು',
  'homeBanner4': 'ಶೋಧನೆ ಆಯ್ಕೆಗಳು',
  'homeBanner4.2': 'ವಿವಿಧ ಪ್ರಶ್ನೆಗಳಿಂದ ಆಯ್ಕೆಮಾಡಿ',
  'homeBanner4.3': 'ಕ್ಯುರೇಟೆಡ್ ಪ್ರಶ್ನೆಗಳ ಪರಿಪೂರ್ಣ ಪಟ್ಟಿಯನ್ನು ಪಡೆಯಲು ಬೋರ್ಡ್, ವರ್ಗ, ತೊಂದರೆ, ಅಂಕಗಳು, ಪ್ರಶ್ನೆಗಳ ಸಂಖ್ಯೆ ಮತ್ತು ಇತರ ನಿಯತಾಂಕಗಳನ್ನು ಆಧರಿಸಿ ಪ್ರಶ್ನೆಗಳನ್ನು ಫಿಲ್ಟರ್ ಮಾಡಿ ಮತ್ತು ಆಯ್ಕೆಮಾಡಿ',
  'qbagDescp3': 'ಇದೀಗ ನಿಮ್ಮ ಖಾತೆಯನ್ನು ರಚಿಸಿ, ಮತ್ತು QBaG ಅನ್ನು ನಿಮ್ಮ ಪೇಪರ್ ಸೆಟ್ಟರ್ ಅಸಿಸ್ಟೆಂಟ್ ಆಗಿ ಬಳಸಿ.',
  'qbagDescp4': 'QBaG ನ ಹೆಚ್ಚಿನ ವೈಶಿಷ್ಟ್ಯಗಳನ್ನು ಅನ್ವೇಷಿಸಲು, ಪ್ರಾರಂಭಿಸಲು ಖಾತೆಯನ್ನು ರಚಿಸಿ.',
  'footer': 'ನಮ್ಮನ್ನು ಹಿಂಬಾಲಿಸಿ',
  'register': 'ನೋಂದಣಿ',
  'login': 'ಲಾಗಿನ್ ಮಾಡಿ',
  'name': 'ಉಪನಾಮ',
  'employment': 'ಉದ್ಯೋಗ',
  'dragNDropProof': "'n' ಡ್ರಾಪ್ ಅನ್ನು ಎಳೆಯಿರಿ ಅಥವಾ ಮಾನ್ಯವಾದ ಗುರುತಿನ ಪುರಾವೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
  'uploadPhotoID': 'ಫೋಟೋ ಐಡಿಯನ್ನು ಅಪ್\u200cಲೋಡ್ ಮಾಡಿ',
  'email': 'ಇಮೇಲ್ ವಿಳಾಸ',
  'userType': 'ಬಳಕೆದಾರರ ಪ್ರಕಾರ',
  'teacherType': 'ಶಿಕ್ಷಕ',
  'othersType': 'ಇತರರು',
  'schoolCollege': 'ಶಾಲೆ/ಕಾಲೇಜು',
  'position': 'ಸ್ಥಾನ',
  'education': 'ಶಿಕ್ಷಣ',
  'password': 'ಗುಪ್ತಪದ',
  'forgotPassword': 'ಪಾಸ್ವರ್ಡ್ ಮರೆತಿರಾ?',
  'dontHaveAnAccountSignUp': 'ಖಾತೆ ಇಲ್ಲವೇ? ಸೈನ್ ಅಪ್ ಮಾಡಿ',
  'alreadyHaveAnAccountSignIn': 'ಈಗಾಗಲೇ ಖಾತೆ ಹೊಂದಿದ್ದೀರ? ಸೈನ್ ಇನ್ ಮಾಡಿ',
  'addQuestion': 'ಪ್ರಶ್ನೆಯನ್ನು ಸೇರಿಸಿ',
  'searchQuestion': 'ಹುಡುಕಾಟ ಪ್ರಶ್ನೆ',
  'generateQuestionPaper': 'ಪ್ರಶ್ನೆ ಪತ್ರಿಕೆಯನ್ನು ರಚಿಸಿ',
  'viewPastPapers': 'ರಚಿಸಲಾದ ಪೇಪರ್ಸ್',
  'noQuestionsFound': 'ಕ್ಷಮಿಸಿ, ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ',
  'contributeQuestions': 'ಪ್ರಶ್ನೆಗಳನ್ನು ಕೊಡುಗೆ ನೀಡಿ',
  'myQuestions': 'ನನ್ನ ಪ್ರಶ್ನೆಗಳು',
  'myTemplates': 'ನನ್ನ ಟೆಂಪ್ಲೇಟ್\u200cಗಳು',
  'questionDetails': 'ಪ್ರಶ್ನೆ ವಿವರಗಳು',
  'board': 'ಬೋರ್ಡ್',
  'langMedium': 'ಮಂಡಳಿಯ ಮಾಧ್ಯಮ',
  'grade': 'ಗ್ರಿಡ್',
  'questionType': 'ಪ್ರಶ್ನೆ ಪ್ರಕಾರ',
  'mcq': 'ಬಹು ಆಯ್ಕೆಯ ಪ್ರಶ್ನೆಗಳು',
  'oneWord': 'ಒಂದು ಪದ ಅಥವಾ ವಾಕ್ಯ',
  'fillInTheBlanks': 'ಬಿಟ್ಟ ಸ್ಥಳ ತುಂಬಿರಿ',
  'matchTheFollowing': 'ಕೆಳಗಿನವುಗಳನ್ನು ಹೊಂದಿಸಿ',
  'difficulty': 'ಕಷ್ಟ',
  'easy': 'ಸುಲಭ',
  'medium': 'ಮಾಧ್ಯಮ',
  'hard': 'ಕಠಿಣ',
  'mark': 'ಮಾರ್ಕ್',
  'marks': 'ಗುರುತುಗಳು',
  'subject': 'ವಿಷಯ',
  'typeKeywordsAndPressEnter': 'ವಿಷಯಗಳನ್ನು ಟೈಪ್ ಮಾಡಿ ಮತ್ತು ಎಂಟರ್ ಒತ್ತಿರಿ',
  'question': 'ಪ್ರಶ್ನೆ',
  'questions': 'ಪ್ರಶ್ನೆಗಳು',
  'numQuestions': 'ಪ್ರಶ್ನೆಗಳ ಸಂಖ್ಯೆ',
  'key': 'ಕೀ',
  'value': 'ಮೌಲ್ಯ',
  'addNew': 'ಹೊಸದನ್ನು ಸೇರಿಸಿ',
  'remove': 'ತೆಗೆದುಹಾಕಿ',
  'answer': 'ಉತ್ತರ',
  'answers': 'ಉತ್ತರಗಳು',
  'columnA': 'ಕಾಲಂ ಎ',
  'columnB': 'ಅಂಕಣ ಬಿ',
  'correctOption': 'ಸರಿಯಾದ ಆಯ್ಕೆ',
  'wrongOpts': 'ತಪ್ಪು ಆಯ್ಕೆಗಳು',
  'wrongOption': 'ತಪ್ಪು ಆಯ್ಕೆಗಳನ್ನು ಟೈಪ್ ಮಾಡಿ ಮತ್ತು ಎಂಟರ್ ಒತ್ತಿರಿ',
  'back': 'ಹಿಂದೆ',
  'next': 'ಮುಂದೆ',
  'enterQuestion': 'ಪ್ರಶ್ನೆಯನ್ನು ನಮೂದಿಸಿ',
  'addAnotherQuestion': 'ಇನ್ನೊಂದು ಪ್ರಶ್ನೆಯನ್ನು ಸೇರಿಸಿ',
  'enterQuestionSuccess': 'ನಿಮ್ಮ ಪ್ರಶ್ನೆಗೆ ಧನ್ಯವಾದಗಳು.',
  'enterQuestionError': 'ಅಯ್ಯೋ! ಇದೇ ರೀತಿಯ ಪ್ರಶ್ನೆ ಈಗಾಗಲೇ ಅಸ್ತಿತ್ವದಲ್ಲಿದೆ!',
  'search': 'ಹುಡುಕಿ Kannada',
  'exportPDF': 'PDF ಗೆ ಮುದ್ರಿಸು',
  'reviewQuestion': 'ವಿಮರ್ಶೆ ಪ್ರಶ್ನೆ',
  'submitQuestion': 'ಪ್ರಶ್ನೆಯನ್ನು ಸಲ್ಲಿಸಿ',
  'invalidRegistration': 'ಅಮಾನ್ಯ ನೋಂದಣಿ ಡೇಟಾ! ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ',
  'verifyEmail': 'ನೀಡಿರುವ ಇಮೇಲ್ ವಿಳಾಸದಲ್ಲಿ ಇಮೇಲ್ ಪರಿಶೀಲನೆ ಲಿಂಕ್ ಅನ್ನು ಕಳುಹಿಸಲಾಗಿದೆ.\nಖಾತೆಯ ಸೆಟಪ್ ಅನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಮೇಲ್ ಅನ್ನು ಪರಿಶೀಲಿಸಿ.\nಪರಿಶೀಲನೆ ಲಿಂಕ್ 24 ಗಂಟೆಗಳವರೆಗೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ',
  'loginError1': 'ಅಮಾನ್ಯವಾದ ಲಾಗಿನ್ ರುಜುವಾತುಗಳು! ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ',
  'loginError2': 'ದಯವಿಟ್ಟು ನಿಮ್ಮ ಇಮೇಲ್ ಅನ್ನು ಮೌಲ್ಯೀಕರಿಸಿ! ನಿಮ್ಮ ಇನ್ಬಾಕ್ಸ್ ಪರಿಶೀಲಿಸಿ',
  'dashboard': 'ಡ್ಯಾಶ್\u200cಬೋರ್ಡ್',
  'viewIDProof': 'ID ಪುರಾವೆಯನ್ನು ವೀಕ್ಷಿಸಿ',
  'changePassword': 'ಗುಪ್ತಪದವನ್ನು ಬದಲಿಸಿ',
  'changePasswordError': 'ಹಳೆಯ ಪಾಸ್\u200cವರ್ಡ್ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ',
  'oldPassword': 'ಹಳೆಯ ಪಾಸ್ವರ್ಡ್',
  'newPassword': 'ಹೊಸ ಪಾಸ್ವರ್ಡ್',
  'confirmNewPassword': 'ಹೊಸ ಗುಪ್ತಪದವನ್ನು ಖಚಿತಪಡಿಸಿ',
  'logout': 'ಲಾಗ್ ಔಟ್',
  'ok': 'ಸರಿ',
  'submit': 'ಸಲ್ಲಿಸು',
  'change': 'ಬದಲಾಯಿಸಿ',
  'backToHome': 'ಮರಳಿ ಮನೆಗೆ',
  'pageNotFound': 'ಪುಟ ಕಂಡುಬಂದಿಲ್ಲ',
  'getResetLink': 'ನಿಮ್ಮ ಪಾಸ್\u200cವರ್ಡ್ ಮರುಹೊಂದಿಸುವ ಲಿಂಕ್ ಪಡೆಯಲು ಇಮೇಲ್ ನಮೂದಿಸಿ',
  'enterNewPassword': 'ನಿಮ್ಮ ಹೊಸ ಪಾಸ್\u200cವರ್ಡ್ ನಮೂದಿಸಿ',
  'resetPasswordAlertTitle': 'ಪಾಸ್ವರ್ಡ್ ಅನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಬದಲಾಯಿಸಲಾಗಿದೆ',
  'resetPasswordAlertDescription': 'ನಿಮ್ಮ ಪಾಸ್\u200cವರ್ಡ್ ಅನ್ನು ಯಶಸ್ವಿಯಾಗಿ ಮರುಹೊಂದಿಸಲಾಗಿದೆ.\nದಯವಿಟ್ಟು ಲಾಗಿನ್ ಮಾಡಲು ಮುಂದುವರಿಯಿರಿ',
  'resetPasswordError': 'ಮರುಹೊಂದಿಸುವ ಲಿಂಕ್ ಅವಧಿ ಮೀರಿದೆ! ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ',
  'forgotPasswordError': 'ಅಮಾನ್ಯ ಇಮೇಲ್ ಐಡಿ! ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ',
  'forgotPasswordAlertTitle': 'ಪಾಸ್ವರ್ಡ್ ಲಿಂಕ್ ಅನ್ನು ಮರುಹೊಂದಿಸಿ',
  'forgotPasswordAlertDescription': 'ನೀಡಿರುವ ಇಮೇಲ್ ವಿಳಾಸದಲ್ಲಿ ಮರುಹೊಂದಿಸುವ ಪಾಸ್\u200cವರ್ಡ್ ಲಿಂಕ್ ಅನ್ನು ಕಳುಹಿಸಲಾಗಿದೆ.\nನಿಮ್ಮ ಹೊಸ ಪಾಸ್\u200cವರ್ಡ್ ಹೊಂದಿಸಲು ದಯವಿಟ್ಟು ಲಿಂಕ್ ಅನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿ.\nಮರುಹೊಂದಿಸುವ ಲಿಂಕ್ 24 ಗಂಟೆಗಳವರೆಗೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ',
  'selectQuestions': 'ಪ್ರಶ್ನೆಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ',
  'selectedQuestions': 'ಪ್ರಶ್ನೆಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ',
  'reviewQuestions': 'ಪ್ರಶ್ನೆಗಳನ್ನು ಪರಿಶೀಲಿಸಿ',
  'generatePaper': 'ಪೇಪರ್ ರಚಿಸಿ',
  'savePaper': 'ಪೇಪರ್ ಉಳಿಸಿ',
  'easyQuestions': 'ಸುಲಭ ಪ್ರಶ್ನೆಗಳ ಸಂಖ್ಯೆ',
  'mediumQuestions': 'ಮಧ್ಯಮ ಪ್ರಶ್ನೆಗಳ ಸಂಖ್ಯೆ',
  'hardQuestions': 'ಕಠಿಣ ಪ್ರಶ್ನೆಗಳ ಸಂಖ್ಯೆ',
  'totalQuestions': 'ಪ್ರಶ್ನೆಗಳ ಒಟ್ಟು ಸಂಖ್ಯೆ',
  'totalMarks': 'ಒಟ್ಟು ಅಂಕಗಳು',
  'mcqs': 'ಬಹು ಆಯ್ಕೆಯ ಪ್ರಶ್ನೆಗಳ ಸಂಖ್ಯೆ',
  'oneWords': 'ಒಂದು ಪದ/ವಾಕ್ಯ ಪ್ರಶ್ನೆಗಳ ಸಂಖ್ಯೆ',
  'fillInTheBlankss': 'ಇಲ್ಲ. ಖಾಲಿ ಪ್ರಶ್ನೆಗಳನ್ನು ಭರ್ತಿ ಮಾಡಿ',
  'matchTheFollowings': 'ಸಂ. ಈ ಕೆಳಗಿನ ಪ್ರಶ್ನೆಗಳನ್ನು ಹೊಂದಿಸಿ',
  'paperName': 'ಕಾಗದದ ಹೆಸರು',
  'vettedWarning': 'ಈ ಕೆಳಗಿನ ಪ್ರಶ್ನೆಗಳನ್ನು ಸಮುದಾಯವು ಪರಿಶೀಲಿಸಿಲ್ಲ, ನೀವು ಇನ್ನೂ ಮುಂದುವರಿಸಲು ಬಯಸುವಿರಾ?',
  'requested': 'ವಿನಂತಿಸಿದರು',
  'selected': 'ಆಯ್ಕೆ ಮಾಡಲಾಗಿದೆ',
  'noPapersGenerated': 'ಇನ್ನೂ ಯಾವುದೇ ಪ್ರಶ್ನೆ ಪತ್ರಿಕೆಗಳನ್ನು ರಚಿಸಲಾಗಿಲ್ಲ',
  'noTemplatesSaved': 'ನೀವು ಯಾವುದೇ ಟೆಂಪ್ಲೇಟ್\u200cಗಳನ್ನು ಉಳಿಸಿಲ್ಲ',
  'savePrompt': 'ಈ ಹುಡುಕಾಟವನ್ನು ಟೆಂಪ್ಲೇಟ್ ಆಗಿ ಉಳಿಸಿ',
  'save': 'ಸವ',
  'downvoteModalHead': 'ಡೌನ್\u200cವೋಟ್\u200cಗೆ ಕಾರಣ',
  'downvoteModalSubHead': 'ದಯವಿಟ್ಟು ಪ್ರಶ್ನೆಯನ್ನು ಡೌನ್\u200cವೋಟ್ ಮಾಡಲು ಕಾರಣವನ್ನು ಒದಗಿಸಿ',
  'cancel': 'ರದ್ದುಮಾಡಿ',
  'noSpeechSupport': 'ಭಾಷಣ ಗುರುತಿಸುವಿಕೆಯನ್ನು ಬ್ರೌಸರ್ ಬೆಂಬಲಿಸುವುದಿಲ್ಲ',
  'uploadCSV': 'CSV ಫೈಲ್ ಅನ್ನು ಅಪ್\u200cಲೋಡ್ ಮಾಡಿ',
  'submitFile': 'ಫೈಲ್\u200cಗಳನ್ನು ಸಲ್ಲಿಸಿ',
  'downloadSample': 'ಮಾದರಿಯನ್ನು ಡೌನ್\u200cಲೋಡ್ ಮಾಡಿ',
  'sorryNote': 'ನಮ್ಮನ್ನು ಕ್ಷಮಿಸಿ! ಈ ಪತ್ರಿಕೆಗೆ ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳು ಕಂಡುಬಂದಿಲ್ಲ. ಸಮುದಾಯವು ಅವುಗಳನ್ನು ಅಮಾನ್ಯವೆಂದು ಗುರುತಿಸಿರಬಹುದು ಮತ್ತು ಆದ್ದರಿಂದ ನಮ್ಮ ಸರ್ವರ್\u200cಗಳಿಂದ ಅಳಿಸಲಾಗಿದೆ.', 'extraQuestions': '% ಹೆಚ್ಚುವರಿ ಪ್ರಶ್ನೆಗಳು'},
 'മലയാളം': {'language': 'ഭാഷ മാറ്റുക',
  'qbag': 'ചോദ്യ ബാങ്ക് ജനറേറ്റർ',
  'qbagDescp1': 'വസ്തുനിഷ്ഠമായ ചോദ്യങ്ങളുടെ ഒരു വലിയ ശേഖരത്തിൽ നിന്ന് ചോദ്യ ബാങ്കുകൾ തയ്യാറാക്കാൻ ചോദ്യ ബാങ്ക് ജനറേറ്റർ ഒരു ക്രൗഡ് സോഴ്\u200cസിംഗ് മോഡൽ ഉപയോഗിക്കുന്നു. ഞങ്ങളുടെ ഓട്ടോമേറ്റഡ്, കരുത്തുറ്റ സംവിധാനം ഉപയോഗിച്ച് വിശ്വസനീയമായ ചോദ്യപേപ്പറുകൾ സൃഷ്ടിക്കുന്നതിന് പേപ്പർ സെറ്റർമാർക്കും അക്കാദമിഷ്യന്മാർക്കും QBaG ഒരു ഇന്റർഫേസ് നൽകുന്നു. പാരാമീറ്ററുകളുടെ ഒരു ശ്രേണിയെ അടിസ്ഥാനമാക്കി ചോദ്യങ്ങൾ തിരഞ്ഞെടുക്കാനും മിനിറ്റുകൾക്കുള്ളിൽ നിങ്ങൾ ആഗ്രഹിക്കുന്ന ഫോർമാറ്റിലേക്ക് കയറ്റുമതി ചെയ്യാനും കഴിയും. സംഭാവന ചെയ്ത ഓരോ ചോദ്യവും നിരവധി പരിശോധനകളിലൂടെ കടന്നുപോകുകയും വിദഗ്ധർ പരിശോധിക്കുകയും ചെയ്യുന്നു.',
  'qbagDescp2': 'ഈ ആപ്പ് നിർമ്മിച്ചിരിക്കുന്നത് ടീം എക്സിക്യൂട്ടബിൾസ് ആണ്',
  'homeBanner1': 'ക്രൗഡ് സോഴ്\u200cസ്ഡ് ചോദ്യങ്ങൾ',
  'homeBanner1.2': 'വിവിധ ഉറവിടങ്ങളിൽ നിന്ന് ചോദ്യങ്ങൾ നേടുക',
  'homeBanner1.3': 'ക്രൗഡ്\u200cസോഴ്\u200cസിംഗ് എല്ലാ ഉപയോക്താക്കളെയും സംഭാവന ചെയ്യാൻ പ്രാപ്\u200cതമാക്കുന്നു, ഇത് ഒന്നിലധികം വീക്ഷണങ്ങൾ ശേഖരിക്കുന്നതിനും ചോദ്യങ്ങളുടെ ആർക്കൈവ് വൈവിധ്യവത്കരിക്കുന്നതിനും സഹായിക്കുന്നു. ക്രൗഡ്\u200cസോഴ്\u200cസിംഗ് മാനേജ്\u200cമെന്റ് ഭാരം കുറയ്ക്കുന്നു, കാരണം പ്രധാന ജോലി കൈകാര്യം ചെയ്യുന്നത് ഉപയോക്താവിനെ മാനുവൽ ജോലിയിൽ നിന്ന് മോചിപ്പിക്കുന്ന സംവിധാനമാണ്.',
  'homeBanner2': 'വിശ്വസനീയമായ ചോദ്യങ്ങൾ',
  'homeBanner2.2': 'പരിശോധിച്ചുറപ്പിച്ചതും സാധൂകരിച്ചതുമായ ചോദ്യങ്ങൾ',
  'homeBanner2.3': 'സംഭാവന ചെയ്ത ഓരോ ചോദ്യവും ഓട്ടോമേറ്റഡ് ടെസ്റ്റിന്റെ ഒരു പരമ്പരയിലൂടെ കടന്നുപോകുന്നു, അത് പിന്നീട് വിദഗ്ധർ സൂക്ഷ്മമായി പരിശോധിക്കുന്നു',
  'homeBanner3': 'കയറ്റുമതി',
  'homeBanner3.2': 'ആവശ്യമുള്ള ഫോർമാറ്റിൽ ചോദ്യങ്ങൾ എക്സ്പോർട്ട് ചെയ്യുക',
  'homeBanner3.3': 'തിരഞ്ഞെടുത്ത ചോദ്യങ്ങൾ ഒരു ചോദ്യപേപ്പറാക്കി മാറ്റാനും PDF, CSV അല്ലെങ്കിൽ excel ഫോർമാറ്റിലേക്കും കയറ്റുമതി ചെയ്യാനും കഴിയും',
  'homeBanner4': 'ഫിൽട്രേഷൻ ഓപ്ഷനുകൾ',
  'homeBanner4.2': 'വിവിധ ചോദ്യങ്ങളിൽ നിന്ന് തിരഞ്ഞെടുക്കുക',
  'homeBanner4.3': 'ക്യൂറേറ്റ് ചെയ്ത ചോദ്യങ്ങളുടെ മികച്ച ലിസ്റ്റ് ലഭിക്കുന്നതിന് ബോർഡ്, ക്ലാസ്, ബുദ്ധിമുട്ട്, മാർക്കുകൾ, ചോദ്യങ്ങളുടെ എണ്ണം, മറ്റ് പാരാമീറ്ററുകൾ എന്നിവ അടിസ്ഥാനമാക്കി ചോദ്യങ്ങൾ ഫിൽട്ടർ ചെയ്ത് തിരഞ്ഞെടുക്കുക',
  'qbagDescp3': 'ഇപ്പോൾ നിങ്ങളുടെ അക്കൗണ്ട് സൃഷ്ടിക്കുക, നിങ്ങളുടെ പേപ്പർ സെറ്റർ അസിസ്റ്റന്റായി QBaG ഉപയോഗിക്കുക.',
  'qbagDescp4': 'QBaG-ന്റെ കൂടുതൽ സവിശേഷതകൾ പര്യവേക്ഷണം ചെയ്യാൻ, ആരംഭിക്കുന്നതിന് ഒരു അക്കൗണ്ട് സൃഷ്ടിക്കുക.',
  'footer': 'ഞങ്ങളെ പിന്തുടരുക',
  'register': 'രജിസ്റ്റർ ചെയ്യുക',
  'login': 'ലോഗിൻ',
  'name': 'കുടുംബപ്പേര്',
  'employment': 'തൊഴിൽ',
  'dragNDropProof': "'n' വലിച്ചിടുക അല്ലെങ്കിൽ സാധുവായ ഒരു ഐഡന്റിറ്റി പ്രൂഫ് തിരഞ്ഞെടുക്കുക",
  'uploadPhotoID': 'ഫോട്ടോ ഐഡി അപ്\u200cലോഡ് ചെയ്യുക',
  'email': 'ഈ - മെയില് വിലാസം',
  'userType': 'ഉപയോക്തൃ തരം',
  'teacherType': 'ടീച്ചർ',
  'othersType': 'മറ്റുള്ളവ',
  'schoolCollege': 'സ്കൂൾ/കോളേജ്',
  'position': 'സ്ഥാനം',
  'education': 'വിദ്യാഭ്യാസം',
  'password': 'Password',
  'forgotPassword': 'പാസ്വേഡ് മറന്നോ?',
  'dontHaveAnAccountSignUp': 'അക്കൗണ്ട് ഇല്ലേ? സൈൻ അപ്പ് ചെയ്യുക',
  'alreadyHaveAnAccountSignIn': 'ഇതിനകം ഒരു അക്കൗണ്ട് ഉണ്ടോ? സൈൻ ഇൻ',
  'addQuestion': 'ചോദ്യം ചേർക്കുക',
  'searchQuestion': 'തിരയൽ ചോദ്യം',
  'generateQuestionPaper': 'ചോദ്യപേപ്പർ ജനറേറ്റ് ചെയ്യുക',
  'viewPastPapers': 'സൃഷ്ടിച്ച പേപ്പറുകൾ',
  'noQuestionsFound': 'ക്ഷമിക്കണം, ചോദ്യങ്ങളൊന്നും കണ്ടെത്തിയില്ല',
  'contributeQuestions': 'ചോദ്യങ്ങൾ സംഭാവന ചെയ്യുക',
  'myQuestions': 'എന്റെ ചോദ്യങ്ങൾ',
  'myTemplates': 'എന്റെ ടെംപ്ലേറ്റുകൾ',
  'questionDetails': 'ചോദ്യത്തിന്റെ വിശദാംശങ്ങൾ',
  'board': 'ബോർഡ്',
  'langMedium': 'ബോർഡ് മീഡിയം',
  'grade': 'ഗ്രിഡ്',
  'questionType': 'ചോദ്യ തരം',
  'mcq': 'ഒന്നിലധികം ചോയ്സ് ചോദ്യങ്ങൾ',
  'oneWord': 'ഒരു വാക്ക് അല്ലെങ്കിൽ വാക്യം',
  'fillInTheBlanks': 'വിട്ട ഭാഗം പൂരിപ്പിക്കുക',
  'matchTheFollowing': 'ഇനിപ്പറയുന്നവ പൊരുത്തപ്പെടുത്തുക',
  'difficulty': 'ബുദ്ധിമുട്ട്',
  'easy': 'എളുപ്പം',
  'medium': 'ഇടത്തരം',
  'hard': 'കഠിനമായ',
  'mark': 'അടയാളപ്പെടുത്തുക',
  'marks': 'മാർക്ക്',
  'subject': 'വിഷയം',
  'typeKeywordsAndPressEnter': 'വിഷയങ്ങൾ ടൈപ്പ് ചെയ്ത് എന്റർ അമർത്തുക',
  'question': 'ചോദ്യം',
  'questions': 'ചോദ്യങ്ങൾ',
  'numQuestions': 'ചോദ്യങ്ങളുടെ എണ്ണം',
  'key': 'താക്കോൽ',
  'value': 'മൂല്യം',
  'addNew': 'പുതിയത് ചേർക്കുക',
  'remove': 'നീക്കം ചെയ്യുക',
  'answer': 'ഉത്തരം',
  'answers': 'ഉത്തരങ്ങൾ',
  'columnA': 'കോളം എ',
  'columnB': 'കോളം ബി',
  'correctOption': 'ശരിയായ ഓപ്ഷൻ',
  'wrongOpts': 'തെറ്റായ ഓപ്ഷനുകൾ',
  'wrongOption': 'തെറ്റായ ഓപ്ഷനുകൾ ടൈപ്പ് ചെയ്ത് എന്റർ അമർത്തുക',
  'back': 'തിരികെ',
  'next': 'അടുത്തത്',
  'enterQuestion': 'ചോദ്യം നൽകുക',
  'addAnotherQuestion': 'മറ്റൊരു ചോദ്യം ചേർക്കുക',
  'enterQuestionSuccess': 'നിങ്ങളുടെ ചോദ്യത്തിന് നന്ദി.',
  'enterQuestionError': 'ശ്ശോ! സമാനമായ ഒരു ചോദ്യം ഇതിനകം നിലവിലുണ്ട്!',
  'search': 'തിരയുക',
  'exportPDF': 'PDF-ലേക്ക് പ്രിന്റ് ചെയ്യുക',
  'reviewQuestion': 'ചോദ്യം അവലോകനം ചെയ്യുക',
  'submitQuestion': 'ചോദ്യം സമർപ്പിക്കുക',
  'invalidRegistration': 'അസാധുവായ രജിസ്ട്രേഷൻ ഡാറ്റ! ദയവായി വീണ്ടും ശ്രമിക്കുക',
  'verifyEmail': 'നൽകിയിരിക്കുന്ന ഇമെയിൽ വിലാസത്തിൽ ഒരു ഇമെയിൽ സ്ഥിരീകരണ ലിങ്ക് അയച്ചു.\nഅക്കൗണ്ട് സജ്ജീകരണം പൂർത്തിയാക്കാൻ നിങ്ങളുടെ ഇമെയിൽ പരിശോധിക്കുക.\nസ്ഥിരീകരണ ലിങ്ക് 24 മണിക്കൂർ സാധുതയുള്ളതാണ്',
  'loginError1': 'അസാധുവായ ലോഗിൻ ക്രെഡൻഷ്യലുകൾ! ദയവായി വീണ്ടും ശ്രമിക്കുക',
  'loginError2': 'ദയവായി നിങ്ങളുടെ ഇമെയിൽ സാധൂകരിക്കുക! നിങ്ങളുടെ ഇൻബോക്സ് പരിശോധിക്കുക',
  'dashboard': 'ഡാഷ്ബോർഡ്',
  'viewIDProof': 'ഐഡി പ്രൂഫ് കാണുക',
  'changePassword': 'പാസ്വേഡ് മാറ്റുക',
  'changePasswordError': 'പഴയ പാസ്\u200cവേഡ് തെറ്റാണ്. ദയവായി വീണ്ടും ശ്രമിക്കുക',
  'oldPassword': 'പഴയ പാസ്വേഡ്',
  'newPassword': 'പുതിയ പാസ്വേഡ്',
  'confirmNewPassword': 'പുതിയ പാസ്\u200cവേഡ് സ്ഥിരീകരിക്കുക',
  'logout': 'ലോഗ് ഔട്ട് ചെയ്യുക',
  'ok': 'ശരി',
  'submit': 'സമർപ്പിക്കുക',
  'change': 'മാറ്റുക',
  'backToHome': 'തിരികെ വീട്ടിലേക്ക്',
  'pageNotFound': 'പേജ് കണ്ടെത്തിയില്ല',
  'getResetLink': 'നിങ്ങളുടെ പാസ്\u200cവേഡ് റീസെറ്റ് ലിങ്ക് ലഭിക്കാൻ ഇമെയിൽ നൽകുക',
  'enterNewPassword': 'നിങ്ങളുടെ പുതിയ പാസ്\u200cവേഡ് നൽകുക',
  'resetPasswordAlertTitle': 'പാസ്\u200cവേഡ് വിജയകരമായി മാറ്റി',
  'resetPasswordAlertDescription': 'നിങ്ങളുടെ പാസ്\u200cവേഡ് വിജയകരമായി പുനഃസജ്ജമാക്കി.\nദയവായി ലോഗിൻ ചെയ്യാൻ തുടരുക',
  'resetPasswordError': 'റീസെറ്റ് ലിങ്ക് കാലഹരണപ്പെട്ടു! ദയവായി വീണ്ടും ശ്രമിക്കുക',
  'forgotPasswordError': 'ഇമെയിൽ ഐഡി അസാധുവാണ്! ദയവായി വീണ്ടും ശ്രമിക്കുക',
  'forgotPasswordAlertTitle': 'പാസ്\u200cവേഡ് ലിങ്ക് പുനഃസജ്ജമാക്കുക',
  'forgotPasswordAlertDescription': 'നൽകിയിരിക്കുന്ന ഇമെയിൽ വിലാസത്തിൽ ഒരു റീസെറ്റ് പാസ്\u200cവേഡ് ലിങ്ക് അയച്ചു.\nനിങ്ങളുടെ പുതിയ പാസ്\u200cവേഡ് സജ്ജീകരിക്കാൻ ലിങ്കിൽ ക്ലിക്ക് ചെയ്യുക.\nറീസെറ്റ് ലിങ്ക് 24 മണിക്കൂർ സാധുതയുള്ളതാണ്',
  'selectQuestions': 'ചോദ്യങ്ങൾ തിരഞ്ഞെടുക്കുക',
  'selectedQuestions': 'ചോദ്യങ്ങൾ തിരഞ്ഞെടുത്തു',
  'reviewQuestions': 'ചോദ്യങ്ങൾ അവലോകനം ചെയ്യുക',
  'generatePaper': 'പേപ്പർ സൃഷ്ടിക്കുക',
  'savePaper': 'പേപ്പർ സംരക്ഷിക്കുക',
  'easyQuestions': 'എളുപ്പമുള്ള ചോദ്യങ്ങളുടെ എണ്ണം',
  'mediumQuestions': 'മീഡിയം ചോദ്യങ്ങളുടെ എണ്ണം',
  'hardQuestions': 'കഠിനമായ ചോദ്യങ്ങളുടെ എണ്ണം',
  'totalQuestions': 'ചോദ്യങ്ങളുടെ ആകെ എണ്ണം',
  'totalMarks': 'ആകെ മാർക്ക്',
  'mcqs': 'മൾട്ടിപ്പിൾ ചോയ്\u200cസ് ചോദ്യങ്ങളുടെ എണ്ണം',
  'oneWords': 'ഒരു വാക്ക്/വാക്യം ചോദ്യങ്ങളുടെ എണ്ണം',
  'fillInTheBlankss': 'നമ്പർ. ശൂന്യമായ ചോദ്യങ്ങൾ പൂരിപ്പിക്കുക',
  'matchTheFollowings': 'നമ്പർ. ഇനിപ്പറയുന്ന ചോദ്യങ്ങൾ പൊരുത്തപ്പെടുത്തുക',
  'paperName': 'പേപ്പർ പേര്',
  'vettedWarning': 'ഇനിപ്പറയുന്ന ചോദ്യങ്ങൾ കമ്മ്യൂണിറ്റി പരിശോധിച്ചിട്ടില്ല, നിങ്ങൾക്ക് ഇപ്പോഴും തുടരാൻ താൽപ്പര്യമുണ്ടോ?',
  'requested': 'അഭ്യർത്ഥിച്ചു',
  'selected': 'തിരഞ്ഞെടുത്തു',
  'noPapersGenerated': 'ചോദ്യപേപ്പറുകളൊന്നും ഇതുവരെ സൃഷ്ടിച്ചിട്ടില്ല',
  'noTemplatesSaved': 'നിങ്ങൾ ടെംപ്ലേറ്റുകളൊന്നും സംരക്ഷിച്ചിട്ടില്ല',
  'savePrompt': 'ഈ തിരയൽ ഒരു ടെംപ്ലേറ്റായി സംരക്ഷിക്കുക',
  'save': 'സാവ',
  'downvoteModalHead': 'ഡൗൺവോട്ടിനുള്ള കാരണം',
  'downvoteModalSubHead': 'ചോദ്യം കുറഞ്ഞ വോട്ട് ചെയ്യുന്നതിനുള്ള കാരണം നൽകുക',
  'cancel': 'റദ്ദാക്കുക',
  'noSpeechSupport': 'സംഭാഷണം തിരിച്ചറിയുന്നതിനെ ബ്രൗസർ പിന്തുണയ്ക്കുന്നില്ല',
  'uploadCSV': 'CSV ഫയൽ അപ്\u200cലോഡ് ചെയ്യുക',
  'submitFile': 'ഫയലുകൾ സമർപ്പിക്കുക',
  'downloadSample': 'സാമ്പിൾ ഡൗൺലോഡ് ചെയ്യുക',
  'sorryNote': 'ഞങ്ങളോട് ക്ഷമിക്കുക! ഈ പേപ്പറിന് ചോദ്യങ്ങളൊന്നും കണ്ടെത്തിയില്ല. അവ കമ്മ്യൂണിറ്റി അസാധുവായി അടയാളപ്പെടുത്തിയിരിക്കാം, അതിനാൽ ഞങ്ങളുടെ സെർവറുകളിൽ നിന്ന് ഇല്ലാതാക്കിയിരിക്കാം.', 'extraQuestions': 'അധിക ചോദ്യങ്ങളുടെ %'},
 'नेपाली': {'language': 'भाषा परिवर्तन गर्नुहोस्',
  'qbag': 'प्रश्न बैंक जेनरेटर',
  'qbagDescp1': 'प्रश्न बैंक जेनरेटरले वस्तुगत प्रश्नहरूको ठूलो पोखरीबाट प्रश्न बैंकहरू तयार गर्न क्राउड सोर्सिङ मोडेल प्रयोग गर्दछ। QBaG ले पेपर सेटरहरू र शिक्षाविद्हरूका लागि हाम्रो स्वचालित र बलियो प्रणाली प्रयोग गरेर भरपर्दो प्रश्नपत्रहरू उत्पन्न गर्न इन्टरफेस प्रदान गर्दछ। प्रश्नहरू प्यारामिटरहरूको दायराको आधारमा चयन गर्न सकिन्छ र मिनेटमा तपाईंको मनपर्ने ढाँचामा निर्यात गर्न सकिन्छ। योगदान गरिएको प्रत्येक प्रश्न धेरै जाँचहरू मार्फत पारित गरिन्छ र विशेषज्ञहरूद्वारा जाँच गरिन्छ।',
  'qbagDescp2': 'यो एप Team-Executables द्वारा बनाइएको हो',
  'homeBanner1': 'क्राउडसोर्स गरिएका प्रश्नहरू',
  'homeBanner1.2': 'विभिन्न स्रोतहरूबाट प्रश्नहरू प्राप्त गर्नुहोस्',
  'homeBanner1.3': 'क्राउडसोर्सिङले सबै प्रयोगकर्ताहरूलाई योगदान दिन सक्षम बनाउँछ, यसले धेरै दृष्टिकोणहरू भेला गर्न र प्रश्नहरूको सङ्ग्रहलाई विविधीकरण गर्न मद्दत गर्छ। क्राउडसोर्सिङले व्यवस्थापनको बोझ कम गर्छ किनभने मुख्य काम प्रणालीद्वारा ह्यान्डल गरिन्छ जसले प्रयोगकर्तालाई म्यानुअल कामबाट मुक्त गर्छ।',
  'homeBanner2': 'भरपर्दो प्रश्नहरू',
  'homeBanner2.2': 'प्रमाणित र मान्य प्रश्नहरू',
  'homeBanner2.3': 'प्रत्येक प्रश्नले योगदान गरेको स्वचालित परीक्षणको शृङ्खलाबाट पास हुन्छ, जसलाई त्यसपछि विशेषज्ञहरूद्वारा जाँच गरिन्छ',
  'homeBanner3': 'निर्यात गर्नुहोस्',
  'homeBanner3.2': 'वांछित ढाँचामा प्रश्नहरू निर्यात गर्नुहोस्',
  'homeBanner3.3': 'चयन गरिएका प्रश्नहरूलाई प्रश्नपत्रमा रूपान्तरण गर्न सकिन्छ र PDF, CSV वा एक्सेल ढाँचामा निर्यात गर्न सकिन्छ',
  'homeBanner4': 'निस्पंदन विकल्पहरू',
  'homeBanner4.2': 'विभिन्न प्रश्नहरूबाट छान्नुहोस्',
  'homeBanner4.3': 'क्यूरेट गरिएका प्रश्नहरूको सही सूची प्राप्त गर्न बोर्ड, कक्षा, कठिनाई, अंक, प्रश्नहरूको संख्या र अन्य प्यारामिटरहरूमा आधारित प्रश्नहरू फिल्टर गर्नुहोस् र छनौट गर्नुहोस्।',
  'qbagDescp3': 'अहिले नै आफ्नो खाता बनाउनुहोस्, र QBaG लाई आफ्नो पेपर सेटर सहायकको रूपमा प्रयोग गर्नुहोस्।',
  'qbagDescp4': 'QBaG को थप सुविधाहरू अन्वेषण गर्न, सुरु गर्न एउटा खाता सिर्जना गर्नुहोस्।',
  'footer': 'हामीलाई पछ्याउनुहोस्',
  'register': 'दर्ता गर्नुहोस्',
  'login': 'लग - इन',
  'name': 'उपनाम',
  'employment': 'रोजगारी',
  'dragNDropProof': "ड्र्याग 'एन' ड्रप गर्नुहोस् वा वैध पहिचान प्रमाण चयन गर्नुहोस्",
  'uploadPhotoID': 'फोटो ID अपलोड गर्नुहोस्',
  'email': 'इ - मेल ठेगाना',
  'userType': 'प्रयोगकर्ता प्रकार',
  'teacherType': 'शिक्षक',
  'othersType': 'अरू',
  'schoolCollege': 'विद्यालय/कलेज',
  'position': 'स्थिति',
  'education': 'शिक्षा',
  'password': 'पासवर्ड',
  'forgotPassword': 'पासवर्ड भुल्नु भयो?',
  'dontHaveAnAccountSignUp': 'खाता छैन? साइन अप',
  'alreadyHaveAnAccountSignIn': 'पहिले नै खाता छ? साइन इन गर्नुहोस्',
  'addQuestion': 'प्रश्न थप्नुहोस्',
  'searchQuestion': 'प्रश्न खोज्नुहोस्',
  'generateQuestionPaper': 'प्रश्नपत्र उत्पन्न गर्नुहोस्',
  'viewPastPapers': 'उत्पन्न कागजातहरू',
  'noQuestionsFound': 'माफ गर्नुहोस्, कुनै प्रश्न भेटिएन',
  'contributeQuestions': 'प्रश्नहरू योगदान गर्नुहोस्',
  'myQuestions': 'मेरा प्रश्नहरू',
  'myTemplates': 'मेरो टेम्प्लेटहरू',
  'questionDetails': 'प्रश्न विवरण',
  'board': 'बोर्ड',
  'langMedium': 'बोर्डको माध्यम',
  'grade': 'ग्रिड',
  'questionType': 'प्रश्नको प्रकार',
  'mcq': 'बहु विकल्प प्रश्नहरू',
  'oneWord': 'एक शब्द वा वाक्य',
  'fillInTheBlanks': 'खालि ठाउँ भर्नुहोस्',
  'matchTheFollowing': 'निम्नसँग मिलाउनुहोस्',
  'difficulty': 'कठिनाई',
  'easy': 'सजिलो',
  'medium': 'मध्यम',
  'hard': 'कडा',
  'mark': 'मार्क',
  'marks': 'मार्क्स',
  'subject': 'विषय',
  'typeKeywordsAndPressEnter': 'विषयहरू टाइप गर्नुहोस् र इन्टर थिच्नुहोस्',
  'question': 'प्रश्न',
  'questions': 'प्रश्नहरू',
  'numQuestions': 'प्रश्नहरूको संख्या',
  'key': 'कुञ्जी',
  'value': 'मूल्य',
  'addNew': 'नयाँ थप्नुहोस्',
  'remove': 'हटाउनुहोस्',
  'answer': 'जवाफ',
  'answers': 'जवाफहरू',
  'columnA': 'स्तम्भ ए',
  'columnB': 'स्तम्भ B',
  'correctOption': 'सही विकल्प',
  'wrongOpts': 'गलत विकल्प',
  'wrongOption': 'गलत विकल्पहरू टाइप गर्नुहोस् र इन्टर थिच्नुहोस्',
  'back': 'पछाडि',
  'next': 'अर्को',
  'enterQuestion': 'प्रश्न प्रविष्ट गर्नुहोस्',
  'addAnotherQuestion': 'अर्को प्रश्न थप्नुहोस्',
  'enterQuestionSuccess': 'तपाईको प्रश्नको लागि धन्यवाद।',
  'enterQuestionError': 'उफ्! यस्तै प्रश्न पहिले नै अवस्थित छ!',
  'search': 'खोज्नुहोस्',
  'exportPDF': 'PDF मा प्रिन्ट गर्नुहोस्',
  'reviewQuestion': 'प्रश्नको समीक्षा गर्नुहोस्',
  'submitQuestion': 'प्रश्न पेश गर्नुहोस्',
  'invalidRegistration': 'अवैध दर्ता डाटा! फेरि प्रयास गर्नुहोस',
  'verifyEmail': 'दिइएको इमेल ठेगानामा ईमेल प्रमाणिकरण लिङ्क पठाइएको छ।\nखाता सेटअप पूरा गर्न कृपया आफ्नो इमेल प्रमाणित गर्नुहोस्।\nप्रमाणीकरण लिङ्क 24 घण्टाको लागि मान्य छ',
  'loginError1': 'अवैध लगइन प्रमाणहरू! फेरि प्रयास गर्नुहोस',
  'loginError2': 'कृपया आफ्नो इमेल प्रमाणित गर्नुहोस्! आफ्नो इनबक्समा जाँच',
  'dashboard': 'ड्यासबोर्ड',
  'viewIDProof': 'आईडी प्रमाण हेर्नुहोस्',
  'changePassword': 'पासवर्ड परिवर्तन गर्नुहोस्',
  'changePasswordError': 'पुरानो पासवर्ड गलत छ। फेरि प्रयास गर्नुहोस',
  'oldPassword': 'पुरानो पासवर्ड',
  'newPassword': 'नया पासवर्ड',
  'confirmNewPassword': 'नयाँ पासवर्ड पुष्टि गर्नुहोस्',
  'logout': 'बाहिर निस्कनु',
  'ok': 'ठिक छ',
  'submit': 'पेश गर्नुहोस्',
  'change': 'परिवर्तन',
  'backToHome': 'घर फिर्ता',
  'pageNotFound': 'पृष्ठ फेला परेन',
  'getResetLink': 'आफ्नो पासवर्ड रिसेट लिङ्क प्राप्त गर्न इमेल प्रविष्ट गर्नुहोस्',
  'enterNewPassword': 'आफ्नो नयाँ पासवर्ड प्रविष्ट गर्नुहोस्',
  'resetPasswordAlertTitle': 'पासवर्ड सफलतापूर्वक परिवर्तन गरियो',
  'resetPasswordAlertDescription': 'तपाईको पासवर्ड सफलतापूर्वक रिसेट गरिएको छ।\nकृपया लगइन गर्न अगाडि बढ्नुहोस्',
  'resetPasswordError': 'रिसेट लिङ्कको म्याद सकिएको छ! फेरि प्रयास गर्नुहोस',
  'forgotPasswordError': 'अवैध इमेल आईडी! फेरि प्रयास गर्नुहोस',
  'forgotPasswordAlertTitle': 'पासवर्ड लिङ्क रिसेट गर्नुहोस्',
  'forgotPasswordAlertDescription': 'दिइएको इमेल ठेगानामा रिसेट पासवर्ड लिङ्क पठाइएको छ।\nकृपया आफ्नो नयाँ पासवर्ड सेट गर्न लिङ्कमा क्लिक गर्नुहोस्।\nरिसेट लिङ्क 24 घण्टाको लागि मान्य छ',
  'selectQuestions': 'प्रश्नहरू चयन गर्नुहोस्',
  'selectedQuestions': 'प्रश्नहरू चयन गरियो',
  'reviewQuestions': 'प्रश्नहरूको समीक्षा गर्नुहोस्',
  'generatePaper': 'कागज उत्पन्न गर्नुहोस्',
  'savePaper': 'कागज बचत गर्नुहोस्',
  'easyQuestions': 'सजिलो प्रश्नहरूको संख्या',
  'mediumQuestions': 'मध्यम प्रश्नहरूको संख्या',
  'hardQuestions': 'कठिन प्रश्नहरूको संख्या',
  'totalQuestions': 'प्रश्नहरूको कुल संख्या',
  'totalMarks': 'कुल अंक',
  'mcqs': 'बहुविकल्पीय प्रश्नहरूको संख्या',
  'oneWords': 'एक शब्द/वाक्य प्रश्नहरूको संख्या',
  'fillInTheBlankss': 'छैन। खाली प्रश्नहरू भर्नुहोस्',
  'matchTheFollowings': 'न। निम्न प्रश्नहरू मिलाउनुहोस्',
  'paperName': 'कागज नाम',
  'vettedWarning': 'निम्न प्रश्नहरू समुदायद्वारा जाँच गरिएका छैनन्, के तपाईं अझै जारी राख्न चाहनुहुन्छ?',
  'requested': 'अनुरोध गरियो',
  'selected': 'चयन गरियो',
  'noPapersGenerated': 'अहिलेसम्म कुनै प्रश्नपत्रहरू उत्पन्न भएका छैनन्',
  'noTemplatesSaved': 'तपाईंले कुनै पनि टेम्प्लेटहरू बचत गर्नुभएको छैन',
  'savePrompt': 'यस खोजलाई टेम्प्लेटको रूपमा बचत गर्नुहोस्',
  'save': 'सावा',
  'downvoteModalHead': 'Downvote को कारण',
  'downvoteModalSubHead': 'कृपया प्रश्नलाई डाउनभोट गर्ने कारण प्रदान गर्नुहोस्',
  'cancel': 'रद्द गर्नुहोस्',
  'noSpeechSupport': 'ब्राउजरले वाणी पहिचानलाई समर्थन गर्दैन',
  'uploadCSV': 'CSV फाइल अपलोड गर्नुहोस्',
  'submitFile': 'फाइलहरू पेश गर्नुहोस्',
  'downloadSample': 'नमूना डाउनलोड गर्नुहोस्',
  'sorryNote': 'हामीलाई माफ गर! यस पेपरको लागि कुनै प्रश्नहरू फेला परेनन्। तिनीहरू समुदायद्वारा अमान्य चिन्ह लगाइएको हुन सक्छ र त्यसैले हाम्रा सर्भरहरूबाट मेटिएको हुन सक्छ।', 'extraQuestions': 'अतिरिक्त प्रश्नहरूको %'},
 'ଓଡ଼ିଆ': {'language': 'ଭାଷା ପରିବର୍ତ୍ତନ କରନ୍ତୁ |',
  'qbag': 'ପ୍ରଶ୍ନ ବ୍ୟାଙ୍କ ଜେନେରେଟର |',
  'qbagDescp1': 'ପ୍ରଶ୍ନ ବ୍ୟାଙ୍କ ଜେନେରେଟର ଏକ ବୃହତ ପୁଲରୁ ପ୍ରଶ୍ନ ବ୍ୟାଙ୍କଗୁଡିକ ପ୍ରସ୍ତୁତ କରିବାକୁ ଏକ ଭିଡ଼ ସୋର୍ସିଂ ମଡେଲ ବ୍ୟବହାର କରେ | QBaG ଆମର ସ୍ୱୟଂଚାଳିତ ଏବଂ ଦୃ ust ସିଷ୍ଟମ୍ ବ୍ୟବହାର କରି ନିର୍ଭରଯୋଗ୍ୟ ପ୍ରଶ୍ନପତ୍ର ସୃଷ୍ଟି କରିବାକୁ କାଗଜ ସେଟର୍ ଏବଂ ଏକାଡେମିକ୍ମାନଙ୍କ ପାଇଁ ଏକ ଇଣ୍ଟରଫେସ୍ ପ୍ରଦାନ କରେ | ପ୍ରଶ୍ନଗୁଡିକ ବିଭିନ୍ନ ପାରାମିଟର ଉପରେ ଆଧାର କରି ଚୟନ କରାଯାଇପାରିବ ଏବଂ କିଛି ମିନିଟ୍ ମଧ୍ୟରେ ତୁମର ଇଚ୍ଛିତ ଫର୍ମାଟକୁ ରପ୍ତାନି କରାଯାଇପାରିବ | ଯୋଗଦାନ କରାଯାଇଥିବା ପ୍ରତ୍ୟେକ ପ୍ରଶ୍ନ ଅନେକ ଚେକ୍ ମାଧ୍ୟମରେ ପାସ୍ ହୋଇଛି ଏବଂ ବିଶେଷଜ୍ଞଙ୍କ ଦ୍ ve ାରା ମଧ୍ୟ ଯାଞ୍ଚ କରାଯାଇଥାଏ |',
  'qbagDescp2': 'ଏହି ଆପ୍ ଟିମ୍-ଏକଜେକ୍ୟୁଟେବଲ୍ ଦ୍ୱାରା ନିର୍ମିତ |',
  'homeBanner1': 'CROWDSOURCED ପ୍ରଶ୍ନଗୁଡିକ |',
  'homeBanner1.2': 'ବିଭିନ୍ନ ଉତ୍ସରୁ ପ୍ରଶ୍ନ ପାଆନ୍ତୁ |',
  'homeBanner1.3': 'କ୍ରାଉଡସୋର୍ସିଂ ସମସ୍ତ ଉପଭୋକ୍ତାଙ୍କୁ ସହଯୋଗ କରିବାକୁ ସକ୍ଷମ କରେ, ଏହା ଏକାଧିକ ଦୃଷ୍ଟିକୋଣ ସଂଗ୍ରହ କରିବାରେ ସାହାଯ୍ୟ କରେ ଏବଂ ପ୍ରଶ୍ନର ଅଭିଲେଖକୁ ବିବିଧ କରିଥାଏ | କ୍ରାଉଡସୋର୍ସିଂ ପରିଚାଳନା ଭାରକୁ ହ୍ରାସ କରିଥାଏ କାରଣ ମୁଖ୍ୟ କାର୍ଯ୍ୟ ସିଷ୍ଟମ ଦ୍ୱାରା ପରିଚାଳିତ ହୋଇଥାଏ ଯାହା ଉପଭୋକ୍ତାଙ୍କୁ ମାନୁଆଲ କାମରୁ ମୁକ୍ତ କରିଥାଏ |',
  'homeBanner2': 'ନିର୍ଭରଯୋଗ୍ୟ ପ୍ରଶ୍ନଗୁଡିକ |',
  'homeBanner2.2': 'ଯାଞ୍ଚ ଏବଂ ବ valid ଧ ପ୍ରଶ୍ନଗୁଡିକ |',
  'homeBanner2.3': 'ପ୍ରତ୍ୟେକ ପ୍ରଶ୍ନ ଯୋଗଦାନ ସ୍ୱୟଂଚାଳିତ ପରୀକ୍ଷଣର ଏକ କ୍ରମରେ ପାସ୍ କରେ, ଯାହା ପରେ ବିଶେଷଜ୍ଞଙ୍କ ଦ୍ r ାରା ଯାଞ୍ଚ କରାଯାଇଥାଏ |',
  'homeBanner3': 'ରପ୍ତାନି',
  'homeBanner3.2': 'ପ୍ରଶ୍ନଗୁଡିକ ଇଚ୍ଛିତ ଫର୍ମାଟରେ ରପ୍ତାନି କରନ୍ତୁ |',
  'homeBanner3.3': 'ମନୋନୀତ ପ୍ରଶ୍ନଗୁଡିକ ଏକ ପ୍ରଶ୍ନ କାଗଜରେ ରୂପାନ୍ତରିତ ହୋଇପାରିବ ଏବଂ ଏହାକୁ PDF, CSV କିମ୍ବା Excel ଫର୍ମାଟରେ ରପ୍ତାନି କରାଯାଇପାରିବ |',
  'homeBanner4': 'ଫିଲ୍ଟରେସନ୍ ଅପ୍ସନ୍ସ |',
  'homeBanner4.2': 'ବିଭିନ୍ନ ପ୍ରଶ୍ନରୁ ବାଛନ୍ତୁ |',
  'homeBanner4.3': 'ବୋର୍ଡ, ଶ୍ରେଣୀ, ଅସୁବିଧା, ମାର୍କ, ପ୍ରଶ୍ନ ସଂଖ୍ୟା ଏବଂ ଅନ୍ୟାନ୍ୟ ପାରାମିଟର ଉପରେ ଆଧାର କରି ପ୍ରଶ୍ନଗୁଡିକ ଫିଲ୍ଟର୍ ଏବଂ ବାଛନ୍ତୁ |',
  'qbagDescp3': 'ବର୍ତ୍ତମାନ ଆପଣଙ୍କର ଖାତା ସୃଷ୍ଟି କରନ୍ତୁ, ଏବଂ QBaG କୁ ଆପଣଙ୍କର କାଗଜ ସେଟର୍ ଆସିଷ୍ଟାଣ୍ଟ ଭାବରେ ବ୍ୟବହାର କରନ୍ତୁ |',
  'qbagDescp4': 'QBaG ର ଅଧିକ ବ features ଶିଷ୍ଟ୍ୟଗୁଡିକ ଅନୁସନ୍ଧାନ କରିବାକୁ, ଆରମ୍ଭ କରିବାକୁ ଏକ ଖାତା ସୃଷ୍ଟି କରନ୍ତୁ |',
  'footer': 'ଆମକୁ ଅନୁସରଣ କରନ୍ତୁ |',
  'register': 'ପଞ୍ଜିକରଣ କର |',
  'login': 'ଭିତରକୁ ଯାଉ',
  'name': 'ଉପନାମ',
  'employment': 'ରୋଜଗାର',
  'dragNDropProof': 'ଡ୍ରପ୍ କରନ୍ତୁ କିମ୍ବା ଏକ ବ valid ଧ ପରିଚୟ ପ୍ରମାଣ ବାଛନ୍ତୁ |',
  'uploadPhotoID': 'ଫଟୋ ID ଅପଲୋଡ୍ କରନ୍ତୁ |',
  'email': 'ଈମୈଲ ଠିକଣା',
  'userType': 'ବ୍ୟବହାରକାରୀ ପ୍ରକାର',
  'teacherType': 'ଶିକ୍ଷକ',
  'othersType': 'ଅନ୍ୟମାନେ |',
  'schoolCollege': 'ବିଦ୍ୟାଳୟ / କଲେଜ',
  'position': 'ଅବସ୍ଥାନ',
  'education': 'ଶିକ୍ଷା',
  'password': 'ପାସୱାର୍ଡ',
  'forgotPassword': 'ପାସୱାର୍ଡ଼ ଭୁଲି ଗଲେ କି?',
  'dontHaveAnAccountSignUp': 'ଏକ ଖାତା ନାହିଁ କି? ସାଇନ୍ ଅପ୍ କରନ୍ତୁ',
  'alreadyHaveAnAccountSignIn': 'ପୂର୍ବରୁ ଏକ ଖାତା ଅଛି କି? ଚୁକ୍ତି କରିବା',
  'addQuestion': 'ପ୍ରଶ୍ନ ଯୋଡନ୍ତୁ |',
  'searchQuestion': 'ସନ୍ଧାନ ପ୍ରଶ୍ନ |',
  'generateQuestionPaper': 'ପ୍ରଶ୍ନ ପେପର ସୃଷ୍ଟି କରନ୍ତୁ |',
  'viewPastPapers': 'ଉତ୍ପାଦିତ କାଗଜପତ୍ର |',
  'noQuestionsFound': 'ଦୁ Sorry ଖିତ, କ Questions ଣସି ପ୍ରଶ୍ନ ମିଳିଲା ନାହିଁ |',
  'contributeQuestions': 'ପ୍ରଶ୍ନଗୁଡିକ ଯୋଗଦାନ କରନ୍ତୁ |',
  'myQuestions': 'MyQuestions',
  'myTemplates': 'ମୋର ଟେମ୍ପଲେଟ୍ |',
  'questionDetails': 'ପ୍ରଶ୍ନ ବିବରଣୀ',
  'board': 'ବୋର୍ଡ |',
  'langMedium': 'ବୋର୍ଡର ମଧ୍ୟମ |',
  'grade': 'ଗ୍ରୀଡ୍',
  'questionType': 'ପ୍ରଶ୍ନ ପ୍ରକାର',
  'mcq': 'ଏକାଧିକ ପସନ୍ଦ ପ୍ରଶ୍ନ |',
  'oneWord': 'ଗୋଟିଏ ଶବ୍ଦ ବା ବାକ୍ୟ |',
  'fillInTheBlanks': 'ଶୁନ୍ୟସ୍ଥାନ ପୁରଣ କର',
  'matchTheFollowing': 'ନିମ୍ନଲିଖିତ ସହିତ ମେଳ କରନ୍ତୁ |',
  'difficulty': 'ଅସୁବିଧା',
  'easy': 'ସହଜ',
  'medium': 'ମଧ୍ୟମ',
  'hard': 'କଠିନ',
  'mark': 'ମାର୍କ',
  'marks': 'ଚିହ୍ନଗୁଡିକ',
  'subject': 'ବିଷୟ',
  'typeKeywordsAndPressEnter': 'ବିଷୟଗୁଡିକ ଟାଇପ୍ କରନ୍ତୁ ଏବଂ ଏଣ୍ଟର୍ ଦାବନ୍ତୁ |',
  'question': 'ପ୍ରଶ୍ନ |',
  'questions': 'ପ୍ରଶ୍ନଗୁଡିକ',
  'numQuestions': 'ପ୍ରଶ୍ନର ନା',
  'key': 'ଚାବି',
  'value': 'ମୂଲ୍ୟ',
  'addNew': 'ନୂତନ ଯୋଡନ୍ତୁ |',
  'remove': 'ଅପସାରଣ କରନ୍ତୁ |',
  'answer': 'ଉତ୍ତର',
  'answers': 'ଉତ୍ତରଗୁଡିକ',
  'columnA': 'ସ୍ତମ୍ଭ A',
  'columnB': 'ସ୍ତମ୍ଭ ବି',
  'correctOption': 'ସଠିକ୍ ବିକଳ୍ପ |',
  'wrongOpts': 'ଭୁଲ ବିକଳ୍ପଗୁଡ଼ିକ',
  'wrongOption': 'ଭୁଲ ବିକଳ୍ପ ଟାଇପ୍ କରନ୍ତୁ ଏବଂ ଏଣ୍ଟର୍ ଦାବନ୍ତୁ |',
  'back': 'ପଛକୁ',
  'next': 'ପରବର୍ତ୍ତୀ',
  'enterQuestion': 'ପ୍ରଶ୍ନ ପ୍ରବେଶ କରନ୍ତୁ |',
  'addAnotherQuestion': 'ଅନ୍ୟ ଏକ ପ୍ରଶ୍ନ ଯୋଡନ୍ତୁ |',
  'enterQuestionSuccess': 'ଆପଣଙ୍କ ପ୍ରଶ୍ନ ପାଇଁ ଧନ୍ୟବାଦ |',
  'enterQuestionError': 'OOPS! ଏକ ସମାନ ପ୍ରଶ୍ନ ପୂର୍ବରୁ ବିଦ୍ୟମାନ ଅଛି!',
  'search': 'ସନ୍ଧାନ କର |',
  'exportPDF': 'PDF କୁ ମୁଦ୍ରଣ କରନ୍ତୁ |',
  'reviewQuestion': 'ପ୍ରଶ୍ନ ସମୀକ୍ଷା କରନ୍ତୁ |',
  'submitQuestion': 'ପ୍ରଶ୍ନ ଦାଖଲ କରନ୍ତୁ |',
  'invalidRegistration': 'ଅବ val ଧ ପଞ୍ଜୀକରଣ ତଥ୍ୟ! ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ',
  'verifyEmail': 'ପ୍ରଦତ୍ତ ଇମେଲ ଠିକଣାରେ ଏକ ଇମେଲ ଯାଞ୍ଚ ଲିଙ୍କ ପଠାଯାଇଛି |\nଖାତା ସେଟଅପ୍ ସଂପୂର୍ଣ୍ଣ କରିବାକୁ ଦୟାକରି ଆପଣଙ୍କର ଇମେଲ୍ ଯାଞ୍ଚ କରନ୍ତୁ |\nଯାଞ୍ଚ ଲିଙ୍କ 24 ଘଣ୍ଟା ପାଇଁ ବ valid ଧ ଅଟେ |',
  'loginError1': 'ଅବ val ଧ ଲଗଇନ୍ ପ୍ରମାଣପତ୍ର! ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ',
  'loginError2': 'ଦୟାକରି ଆପଣଙ୍କର ଇମେଲ୍ ବ valid ଧ କରନ୍ତୁ! ଆପଣଙ୍କର ଇନବକ୍ସ ଯାଞ୍ଚ କରନ୍ତୁ |',
  'dashboard': 'ଡ୍ୟାସବୋର୍ଡ |',
  'viewIDProof': 'ID ପ୍ରୁଫ୍ ଦେଖନ୍ତୁ |',
  'changePassword': 'ପାସୱାର୍ଡ ପରିବର୍ତ୍ତନ କରନ୍ତୁ',
  'changePasswordError': 'ପୁରୁଣା ପାସୱାର୍ଡ ଭୁଲ ଅଟେ | ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ',
  'oldPassword': 'ପୁରୁଣା ପ୍ରବେଶ ସବ୍ଦ',
  'newPassword': 'ନୁତନ ପାସ୍ୱାର୍ଡ',
  'confirmNewPassword': 'ନୂତନ ପାସୱାର୍ଡ ନିଶ୍ଚିତ କରନ୍ତୁ |',
  'logout': 'ପ୍ରସ୍ଥାନ କର',
  'ok': 'ଠିକ୍ ଅଛି',
  'submit': 'ଦାଖଲ କରନ୍ତୁ |',
  'change': 'ପରିବର୍ତ୍ତନ',
  'backToHome': 'ଘରକୁ ଫେରନ୍ତୁ |',
  'pageNotFound': 'ପୃଷ୍ଠାଟି ମିଳିଲା ନାହିଁ',
  'getResetLink': 'ଆପଣଙ୍କର ପାସୱାର୍ଡ ପୁନ et ସେଟ୍ ଲିଙ୍କ୍ ପାଇବାକୁ ଇମେଲ୍ ପ୍ରବେଶ କରନ୍ତୁ |',
  'enterNewPassword': 'ଆପଣଙ୍କର ନୂତନ ପାସୱାର୍ଡ ପ୍ରବେଶ କରନ୍ତୁ |',
  'resetPasswordAlertTitle': 'ପାସୱାର୍ଡ ସଫଳତାର ସହିତ ପରିବର୍ତ୍ତିତ ହେଲା |',
  'resetPasswordAlertDescription': 'ଆପଣଙ୍କର ପାସୱାର୍ଡ ସଫଳତାର ସହିତ ପୁନ res ସେଟ୍ ହୋଇଛି |\nଦୟାକରି ଲଗଇନ୍ କରିବାକୁ ଅଗ୍ରଗତି କରନ୍ତୁ |',
  'resetPasswordError': 'ପୁନ Res ସେଟ୍ ଲିଙ୍କ୍ ମିଆଦ ପୂର୍ଣ୍ଣ ହୋଇଛି! ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ',
  'forgotPasswordError': 'ଅବ val ଧ ଇମେଲ୍ ID! ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ',
  'forgotPasswordAlertTitle': 'ପାସୱାର୍ଡ ଲିଙ୍କ୍ ପୁନ Res ସେଟ୍ କରନ୍ତୁ |',
  'forgotPasswordAlertDescription': 'ପ୍ରଦତ୍ତ ଇମେଲ ଠିକଣାରେ ଏକ ପୁନ et ସେଟ୍ ପାସୱାର୍ଡ ଲିଙ୍କ୍ ପଠାଯାଇଛି |\nଆପଣଙ୍କର ନୂତନ ପାସୱାର୍ଡ ସେଟ୍ କରିବାକୁ ଦୟାକରି ଲିଙ୍କରେ କ୍ଲିକ୍ କରନ୍ତୁ |\nପୁନ res ସେଟ୍ ଲିଙ୍କ୍ 24 ଘଣ୍ଟା ପାଇଁ ବ valid ଧ ଅଟେ |',
  'selectQuestions': 'ପ୍ରଶ୍ନଗୁଡିକ ଚୟନ କରନ୍ତୁ |',
  'selectedQuestions': 'ପ୍ରଶ୍ନଗୁଡିକ ଚୟନ କରାଯାଇଛି |',
  'reviewQuestions': 'ପ୍ରଶ୍ନଗୁଡିକ ସମୀକ୍ଷା କରନ୍ତୁ |',
  'generatePaper': 'କାଗଜ ସୃଷ୍ଟି କରନ୍ତୁ |',
  'savePaper': 'କାଗଜ ସଞ୍ଚୟ କରନ୍ତୁ |',
  'easyQuestions': 'ସହଜ ପ୍ରଶ୍ନର ନା',
  'mediumQuestions': 'ମଧ୍ୟମ ପ୍ରଶ୍ନର ନା',
  'hardQuestions': 'କଠିନ ପ୍ରଶ୍ନର ନା',
  'totalQuestions': 'ପ୍ରଶ୍ନର ମୋଟ ସଂଖ୍ୟା |',
  'totalMarks': 'ମୋଟ ମାର୍କ',
  'mcqs': 'ଏକାଧିକ ପସନ୍ଦ ପ୍ରଶ୍ନର ନା',
  'oneWords': 'ଗୋଟିଏ ଶବ୍ଦ / ବାକ୍ୟ ପ୍ରଶ୍ନର ନା',
  'fillInTheBlankss': 'ନା। ଖାଲି ପ୍ରଶ୍ନଗୁଡିକ ପୁରଣ କରନ୍ତୁ |',
  'matchTheFollowings': 'ନା। ନିମ୍ନଲିଖିତ ପ୍ରଶ୍ନଗୁଡ଼ିକ ସହିତ ମେଳ କର |',
  'paperName': 'କାଗଜ ନାମ |',
  'vettedWarning': 'ନିମ୍ନଲିଖିତ ପ୍ରଶ୍ନଗୁଡିକ ସମ୍ପ୍ରଦାୟ ଦ୍ୱାରା ପରୀକ୍ଷିତ ନୁହେଁ, ଆପଣ ତଥାପି ଜାରି ରଖିବାକୁ ଚାହାଁନ୍ତି କି?',
  'requested': 'ଅନୁରୋଧ',
  'selected': 'ମନୋନୀତ |',
  'noPapersGenerated': 'ଏପର୍ଯ୍ୟନ୍ତ କ Question ଣସି ପ୍ରଶ୍ନ ପେପର ସୃଷ୍ଟି ହୋଇନାହିଁ |',
  'noTemplatesSaved': 'ଆପଣ କ any ଣସି ଟେମ୍ପଲେଟ୍ ସଞ୍ଚୟ କରି ନାହାଁନ୍ତି |',
  'savePrompt': 'ଏହି ସନ୍ଧାନକୁ ଏକ ଟେମ୍ପଲେଟ୍ ଭାବରେ ସେଭ୍ କରନ୍ତୁ |',
  'save': 'ସାଭା |',
  'downvoteModalHead': 'ଡାଉନଭୋଟ୍ ପାଇଁ କାରଣ |',
  'downvoteModalSubHead': 'ପ୍ରଶ୍ନକୁ ହ୍ରାସ କରିବା ପାଇଁ ଦୟାକରି ଏକ କାରଣ ପ୍ରଦାନ କରନ୍ତୁ |',
  'cancel': 'ବାତିଲ୍ କରନ୍ତୁ |',
  'noSpeechSupport': 'ବ୍ରାଉଜର୍ ବକ୍ତବ୍ୟ ସ୍ୱୀକୃତିକୁ ସମର୍ଥନ କରେନାହିଁ |',
  'uploadCSV': 'CSV ଫାଇଲ୍ ଅପଲୋଡ୍ କରନ୍ତୁ |',
  'submitFile': 'ଫାଇଲ୍ ଦାଖଲ କରନ୍ତୁ |',
  'downloadSample': 'ନମୁନା ଡାଉନଲୋଡ୍ କରନ୍ତୁ |',
  'sorryNote': 'ଆମେ ଦୁ sorry ଖିତ! ଏହି କାଗଜ ପାଇଁ କ questions ଣସି ପ୍ରଶ୍ନ ମିଳିଲା ନାହିଁ | ସେମାନେ ହୁଏତ ସମ୍ପ୍ରଦାୟ ଦ୍ୱାରା ଅବ alid ଧ ଭାବରେ ଚିହ୍ନିତ ହୋଇଥିବେ ଏବଂ ତେଣୁ ଆମର ସର୍ଭରରୁ ବିଲୋପ ହୋଇଥିବେ |', 'extraQuestions': 'ଅତିରିକ୍ତ ପ୍ରଶ୍ନର%'},
 'ਪੰਜਾਬੀ': {'language': 'ਭਾਸ਼ਾ ਬਦਲੋ',
  'qbag': 'ਪ੍ਰਸ਼ਨ ਬੈਂਕ ਜਨਰੇਟਰ',
  'qbagDescp1': "ਪ੍ਰਸ਼ਨ ਬੈਂਕ ਜਨਰੇਟਰ ਉਦੇਸ਼ ਪ੍ਰਸ਼ਨਾਂ ਦੇ ਇੱਕ ਵੱਡੇ ਪੂਲ ਤੋਂ ਪ੍ਰਸ਼ਨ ਬੈਂਕ ਤਿਆਰ ਕਰਨ ਲਈ ਇੱਕ ਭੀੜ ਸੋਰਸਿੰਗ ਮਾਡਲ ਦੀ ਵਰਤੋਂ ਕਰਦਾ ਹੈ। QBaG ਸਾਡੇ ਸਵੈਚਲਿਤ ਅਤੇ ਮਜਬੂਤ ਸਿਸਟਮ ਦੀ ਵਰਤੋਂ ਕਰਦੇ ਹੋਏ ਭਰੋਸੇਮੰਦ ਪ੍ਰਸ਼ਨ ਪੱਤਰ ਤਿਆਰ ਕਰਨ ਲਈ ਪੇਪਰ ਸੇਟਰਾਂ ਅਤੇ ਅਕਾਦਮਿਕਾਂ ਲਈ ਇੱਕ ਇੰਟਰਫੇਸ ਪ੍ਰਦਾਨ ਕਰਦਾ ਹੈ। ਸਵਾਲਾਂ ਨੂੰ ਕਈ ਮਾਪਦੰਡਾਂ ਦੇ ਆਧਾਰ 'ਤੇ ਚੁਣਿਆ ਜਾ ਸਕਦਾ ਹੈ ਅਤੇ ਮਿੰਟਾਂ ਦੇ ਅੰਦਰ ਤੁਹਾਡੇ ਲੋੜੀਂਦੇ ਫਾਰਮੈਟ ਵਿੱਚ ਨਿਰਯਾਤ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ। ਯੋਗਦਾਨ ਕੀਤੇ ਗਏ ਹਰੇਕ ਸਵਾਲ ਨੂੰ ਕਈ ਜਾਂਚਾਂ ਵਿੱਚੋਂ ਲੰਘਾਇਆ ਜਾਂਦਾ ਹੈ ਅਤੇ ਮਾਹਿਰਾਂ ਦੁਆਰਾ ਜਾਂਚ ਵੀ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
  'qbagDescp2': 'ਇਹ ਐਪ ਟੀਮ-ਐਗਜ਼ੀਕਿਊਟੇਬਲ ਦੁਆਰਾ ਬਣਾਇਆ ਗਿਆ ਹੈ',
  'homeBanner1': 'ਭੀੜ-ਭੜੱਕੇ ਵਾਲੇ ਸਵਾਲ',
  'homeBanner1.2': 'ਵੱਖ-ਵੱਖ ਸਰੋਤਾਂ ਤੋਂ ਸਵਾਲ ਪ੍ਰਾਪਤ ਕਰੋ',
  'homeBanner1.3': 'ਕ੍ਰਾਊਡਸੋਰਸਿੰਗ ਸਾਰੇ ਉਪਭੋਗਤਾਵਾਂ ਨੂੰ ਯੋਗਦਾਨ ਪਾਉਣ ਦੇ ਯੋਗ ਬਣਾਉਂਦਾ ਹੈ, ਇਹ ਕਈ ਦ੍ਰਿਸ਼ਟੀਕੋਣਾਂ ਨੂੰ ਇਕੱਠਾ ਕਰਨ ਵਿੱਚ ਮਦਦ ਕਰਦਾ ਹੈ ਅਤੇ ਸਵਾਲਾਂ ਦੇ ਪੁਰਾਲੇਖ ਨੂੰ ਵਿਭਿੰਨ ਬਣਾਉਂਦਾ ਹੈ। ਕ੍ਰਾਊਡਸੋਰਸਿੰਗ ਪ੍ਰਬੰਧਨ ਬੋਝ ਨੂੰ ਘਟਾਉਂਦੀ ਹੈ ਕਿਉਂਕਿ ਮੁੱਖ ਕੰਮ ਸਿਸਟਮ ਦੁਆਰਾ ਸੰਭਾਲਿਆ ਜਾਂਦਾ ਹੈ ਜੋ ਉਪਭੋਗਤਾ ਨੂੰ ਹੱਥੀਂ ਕੰਮ ਕਰਨ ਤੋਂ ਮੁਕਤ ਕਰਦਾ ਹੈ',
  'homeBanner2': 'ਭਰੋਸੇਯੋਗ ਸਵਾਲ',
  'homeBanner2.2': 'ਪ੍ਰਮਾਣਿਤ ਅਤੇ ਪ੍ਰਮਾਣਿਤ ਸਵਾਲ',
  'homeBanner2.3': 'ਯੋਗਦਾਨ ਪਾਇਆ ਗਿਆ ਹਰੇਕ ਸਵਾਲ ਸਵੈਚਲਿਤ ਟੈਸਟ ਦੀ ਇੱਕ ਲੜੀ ਵਿੱਚੋਂ ਲੰਘਦਾ ਹੈ, ਜਿਸਦੀ ਫਿਰ ਮਾਹਰਾਂ ਦੁਆਰਾ ਜਾਂਚ ਕੀਤੀ ਜਾਂਦੀ ਹੈ',
  'homeBanner3': 'ਨਿਰਯਾਤ',
  'homeBanner3.2': 'ਸਵਾਲਾਂ ਨੂੰ ਲੋੜੀਂਦੇ ਫਾਰਮੈਟ ਵਿੱਚ ਨਿਰਯਾਤ ਕਰੋ',
  'homeBanner3.3': 'ਚੁਣੇ ਗਏ ਪ੍ਰਸ਼ਨਾਂ ਨੂੰ ਪ੍ਰਸ਼ਨ ਪੱਤਰ ਵਿੱਚ ਬਦਲਿਆ ਜਾ ਸਕਦਾ ਹੈ ਅਤੇ PDF, CSV ਜਾਂ ਐਕਸਲ ਫਾਰਮੈਟ ਵਿੱਚ ਨਿਰਯਾਤ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ',
  'homeBanner4': 'ਫਿਲਟਰੇਸ਼ਨ ਵਿਕਲਪ',
  'homeBanner4.2': 'ਕਈ ਤਰ੍ਹਾਂ ਦੇ ਸਵਾਲਾਂ ਵਿੱਚੋਂ ਚੁਣੋ',
  'homeBanner4.3': 'ਚੁਣੇ ਗਏ ਪ੍ਰਸ਼ਨਾਂ ਦੀ ਸੰਪੂਰਨ ਸੂਚੀ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਬੋਰਡ, ਕਲਾਸ, ਮੁਸ਼ਕਲ, ਅੰਕ, ਪ੍ਰਸ਼ਨਾਂ ਦੀ ਸੰਖਿਆ ਅਤੇ ਹੋਰ ਮਾਪਦੰਡਾਂ ਦੇ ਅਧਾਰ ਤੇ ਪ੍ਰਸ਼ਨ ਫਿਲਟਰ ਕਰੋ ਅਤੇ ਚੁਣੋ',
  'qbagDescp3': 'ਹੁਣੇ ਆਪਣਾ ਖਾਤਾ ਬਣਾਓ, ਅਤੇ ਆਪਣੇ ਪੇਪਰ ਸੇਟਰ ਸਹਾਇਕ ਵਜੋਂ QBaG ਦੀ ਵਰਤੋਂ ਕਰੋ।',
  'qbagDescp4': 'QBaG ਦੀਆਂ ਹੋਰ ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ ਦੀ ਪੜਚੋਲ ਕਰਨ ਲਈ, ਸ਼ੁਰੂਆਤ ਕਰਨ ਲਈ ਇੱਕ ਖਾਤਾ ਬਣਾਓ।',
  'footer': "'ਤੇ ਸਾਡੇ ਨਾਲ ਪਾਲਣਾ ਕਰੋ",
  'register': 'ਰਜਿਸਟਰ',
  'login': 'ਲਾਗਿਨ',
  'name': 'ਉਪਨਾਮ',
  'employment': 'ਰੁਜ਼ਗਾਰ',
  'dragNDropProof': "ਡਰੈਗ 'ਐਨ' ਸੁੱਟੋ ਜਾਂ ਇੱਕ ਵੈਧ ਪਛਾਣ ਸਬੂਤ ਚੁਣੋ",
  'uploadPhotoID': 'ਫੋਟੋ ID ਅੱਪਲੋਡ ਕਰੋ',
  'email': 'ਈਮੇਲ ਖਾਤਾ',
  'userType': 'ਉਪਭੋਗਤਾ ਦੀ ਕਿਸਮ',
  'teacherType': 'ਅਧਿਆਪਕ',
  'othersType': 'ਹੋਰ',
  'schoolCollege': 'ਸਕੂਲ/ਕਾਲਜ',
  'position': 'ਸਥਿਤੀ',
  'education': 'ਸਿੱਖਿਆ',
  'password': 'ਪਾਸਵਰਡ',
  'forgotPassword': 'ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ?',
  'dontHaveAnAccountSignUp': 'ਕੀ ਤੁਹਾਡੇ ਕੋਲ ਖਾਤਾ ਨਹੀਂ ਹੈ? ਸਾਇਨ ਅਪ',
  'alreadyHaveAnAccountSignIn': 'ਕੀ ਪਹਿਲਾਂ ਤੋਂ ਹੀ ਖਾਤਾ ਹੈ? ਸਾਈਨ - ਇਨ',
  'addQuestion': 'ਸਵਾਲ ਸ਼ਾਮਲ ਕਰੋ',
  'searchQuestion': 'ਖੋਜ ਸਵਾਲ',
  'generateQuestionPaper': 'ਪ੍ਰਸ਼ਨ ਪੱਤਰ ਤਿਆਰ ਕਰੋ',
  'viewPastPapers': 'ਤਿਆਰ ਕੀਤੇ ਕਾਗਜ਼',
  'noQuestionsFound': 'ਮਾਫ਼ ਕਰਨਾ, ਕੋਈ ਸਵਾਲ ਨਹੀਂ ਮਿਲੇ',
  'contributeQuestions': 'ਸਵਾਲਾਂ ਦਾ ਯੋਗਦਾਨ ਦਿਓ',
  'myQuestions': 'ਮੇਰੇ ਸਵਾਲ',
  'myTemplates': 'ਮੇਰੇ ਟੈਮਪਲੇਟਸ',
  'questionDetails': 'ਪ੍ਰਸ਼ਨ ਵੇਰਵੇ',
  'board': 'ਫੱਟੀ',
  'langMedium': 'ਬੋਰਡ ਦਾ ਮਾਧਿਅਮ',
  'grade': 'ਗਰਿੱਡ',
  'questionType': 'ਸਵਾਲ ਦੀ ਕਿਸਮ',
  'mcq': 'ਬਹੁ-ਚੋਣ ਸਵਾਲ',
  'oneWord': 'ਇੱਕ ਸ਼ਬਦ ਜਾਂ ਵਾਕ',
  'fillInTheBlanks': 'ਖਾਲੀ ਥਾਂਵਾਂ ਨੂੰ ਭਰੋ',
  'matchTheFollowing': 'ਹੇਠ ਲਿਖੇ ਨਾਲ ਮੇਲ ਕਰੋ',
  'difficulty': 'ਮੁਸ਼ਕਲ',
  'easy': 'ਆਸਾਨ',
  'medium': 'ਦਰਮਿਆਨਾ',
  'hard': 'ਸਖ਼ਤ',
  'mark': 'ਮਾਰਕ',
  'marks': 'ਚਿੰਨ੍ਹ',
  'subject': 'ਵਿਸ਼ਾ',
  'typeKeywordsAndPressEnter': 'ਵਿਸ਼ੇ ਟਾਈਪ ਕਰੋ ਅਤੇ ਐਂਟਰ ਦਬਾਓ',
  'question': 'ਸਵਾਲ',
  'questions': 'ਸਵਾਲ',
  'numQuestions': 'ਸਵਾਲਾਂ ਦੀ ਸੰਖਿਆ',
  'key': 'ਕੁੰਜੀ',
  'value': 'ਮੁੱਲ',
  'addNew': 'ਨਵਾਂ ਸ਼ਾਮਲ ਕਰੋ',
  'remove': 'ਹਟਾਓ',
  'answer': 'ਜਵਾਬ',
  'answers': 'ਜਵਾਬ',
  'columnA': 'ਕਾਲਮ ਏ',
  'columnB': 'ਕਾਲਮ ਬੀ',
  'correctOption': 'ਸਹੀ ਵਿਕਲਪ',
  'wrongOpts': 'ਗਲਤ ਵਿਕਲਪ',
  'wrongOption': 'ਗਲਤ ਵਿਕਲਪ ਟਾਈਪ ਕਰੋ ਅਤੇ ਐਂਟਰ ਦਬਾਓ',
  'back': 'ਵਾਪਸ',
  'next': 'ਅਗਲਾ',
  'enterQuestion': 'ਸਵਾਲ ਦਰਜ ਕਰੋ',
  'addAnotherQuestion': 'ਇੱਕ ਹੋਰ ਸਵਾਲ ਸ਼ਾਮਲ ਕਰੋ',
  'enterQuestionSuccess': 'ਤੁਹਾਡੇ ਸਵਾਲ ਲਈ ਧੰਨਵਾਦ।',
  'enterQuestionError': 'ਓਹ! ਇੱਕ ਸਮਾਨ ਸਵਾਲ ਪਹਿਲਾਂ ਹੀ ਮੌਜੂਦ ਹੈ!',
  'search': 'ਖੋਜ',
  'exportPDF': 'PDF ਵਿੱਚ ਪ੍ਰਿੰਟ ਕਰੋ',
  'reviewQuestion': 'ਸਵਾਲ ਦੀ ਸਮੀਖਿਆ ਕਰੋ',
  'submitQuestion': 'ਸਵਾਲ ਦਰਜ ਕਰੋ',
  'invalidRegistration': 'ਅਵੈਧ ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਡੇਟਾ! ਮੁੜ ਕੋਸ਼ਿਸ ਕਰੋ ਜੀ',
  'verifyEmail': "ਦਿੱਤੇ ਗਏ ਈਮੇਲ ਪਤੇ 'ਤੇ ਇੱਕ ਈਮੇਲ ਪੁਸ਼ਟੀਕਰਨ ਲਿੰਕ ਭੇਜਿਆ ਗਿਆ ਹੈ।\nਕਿਰਪਾ ਕਰਕੇ ਖਾਤਾ ਸੈੱਟਅੱਪ ਨੂੰ ਪੂਰਾ ਕਰਨ ਲਈ ਆਪਣੀ ਈਮੇਲ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ।\nਪੁਸ਼ਟੀਕਰਨ ਲਿੰਕ 24 ਘੰਟਿਆਂ ਲਈ ਵੈਧ ਹੈ",
  'loginError1': 'ਅਵੈਧ ਲੌਗਇਨ ਪ੍ਰਮਾਣ ਪੱਤਰ! ਮੁੜ ਕੋਸ਼ਿਸ ਕਰੋ ਜੀ',
  'loginError2': 'ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀ ਈਮੇਲ ਨੂੰ ਪ੍ਰਮਾਣਿਤ ਕਰੋ! ਆਪਣੇ ਇਨਬਾਕਸ ਦੀ ਜਾਂਚ ਕਰੋ',
  'dashboard': 'ਡੈਸ਼ਬੋਰਡ',
  'viewIDProof': 'ਆਈਡੀ ਪਰੂਫ਼ ਵੇਖੋ',
  'changePassword': 'ਪਾਸਵਰਡ ਬਦਲੋ',
  'changePasswordError': 'ਪੁਰਾਣਾ ਪਾਸਵਰਡ ਗਲਤ ਹੈ। ਮੁੜ ਕੋਸ਼ਿਸ ਕਰੋ ਜੀ',
  'oldPassword': 'ਪੁਰਾਣਾ ਪਾਸਵਰਡ',
  'newPassword': 'ਨਵਾਂ ਪਾਸਵਰਡ',
  'confirmNewPassword': 'ਨਵੇਂ ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ',
  'logout': 'ਲਾੱਗ ਆਊਟ, ਬਾਹਰ ਆਉਣਾ',
  'ok': 'ਠੀਕ ਹੈ',
  'submit': 'ਜਮ੍ਹਾਂ ਕਰੋ',
  'change': 'ਬਦਲੋ',
  'backToHome': "ਘਰ 'ਤੇ ਵਾਪਸ ਜਾਓ",
  'pageNotFound': 'ਪੰਨਾ ਮਿਲਿਆ ਨਹੀਂ',
  'getResetLink': 'ਆਪਣਾ ਪਾਸਵਰਡ ਰੀਸੈਟ ਲਿੰਕ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਈਮੇਲ ਦਰਜ ਕਰੋ',
  'enterNewPassword': 'ਆਪਣਾ ਨਵਾਂ ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ',
  'resetPasswordAlertTitle': 'ਪਾਸਵਰਡ ਸਫਲਤਾਪੂਰਵਕ ਬਦਲਿਆ ਗਿਆ',
  'resetPasswordAlertDescription': 'ਤੁਹਾਡਾ ਪਾਸਵਰਡ ਸਫਲਤਾਪੂਰਵਕ ਰੀਸੈਟ ਕੀਤਾ ਗਿਆ ਹੈ।\nਕਿਰਪਾ ਕਰਕੇ ਲੌਗਇਨ ਕਰਨ ਲਈ ਅੱਗੇ ਵਧੋ',
  'resetPasswordError': 'ਰੀਸੈਟ ਲਿੰਕ ਦੀ ਮਿਆਦ ਪੁੱਗ ਗਈ ਹੈ! ਮੁੜ ਕੋਸ਼ਿਸ ਕਰੋ ਜੀ',
  'forgotPasswordError': 'ਅਵੈਧ ਈਮੇਲ ID! ਮੁੜ ਕੋਸ਼ਿਸ ਕਰੋ ਜੀ',
  'forgotPasswordAlertTitle': 'ਪਾਸਵਰਡ ਲਿੰਕ ਰੀਸੈਟ ਕਰੋ',
  'forgotPasswordAlertDescription': "ਦਿੱਤੇ ਗਏ ਈਮੇਲ ਪਤੇ 'ਤੇ ਇੱਕ ਰੀਸੈਟ ਪਾਸਵਰਡ ਲਿੰਕ ਭੇਜਿਆ ਗਿਆ ਹੈ।\nਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਨਵਾਂ ਪਾਸਵਰਡ ਸੈੱਟ ਕਰਨ ਲਈ ਲਿੰਕ 'ਤੇ ਕਲਿੱਕ ਕਰੋ।\nਰੀਸੈਟ ਲਿੰਕ 24 ਘੰਟਿਆਂ ਲਈ ਵੈਧ ਹੈ",
  'selectQuestions': 'ਸਵਾਲ ਚੁਣੋ',
  'selectedQuestions': 'ਸਵਾਲ ਚੁਣੇ ਗਏ',
  'reviewQuestions': 'ਸਵਾਲਾਂ ਦੀ ਸਮੀਖਿਆ ਕਰੋ',
  'generatePaper': 'ਪੇਪਰ ਤਿਆਰ ਕਰੋ',
  'savePaper': 'ਪੇਪਰ ਸੰਭਾਲੋ',
  'easyQuestions': 'ਸੌਖੇ ਸਵਾਲਾਂ ਦੀ ਸੰਖਿਆ',
  'mediumQuestions': 'ਦਰਮਿਆਨੇ ਸਵਾਲਾਂ ਦੀ ਸੰਖਿਆ',
  'hardQuestions': 'ਔਖੇ ਸਵਾਲਾਂ ਦੀ ਗਿਣਤੀ',
  'totalQuestions': 'ਸਵਾਲਾਂ ਦੀ ਕੁੱਲ ਸੰਖਿਆ',
  'totalMarks': 'ਕੁੱਲ ਅੰਕ',
  'mcqs': 'ਬਹੁ-ਚੋਣ ਪ੍ਰਸ਼ਨਾਂ ਦੀ ਸੰਖਿਆ',
  'oneWords': 'ਇੱਕ ਸ਼ਬਦ/ਵਾਕ ਪ੍ਰਸ਼ਨਾਂ ਦੀ ਸੰਖਿਆ',
  'fillInTheBlankss': 'ਨੰ. ਖਾਲੀ ਸਵਾਲਾਂ ਨੂੰ ਭਰੋ',
  'matchTheFollowings': 'ਨੰ. ਹੇਠਾਂ ਦਿੱਤੇ ਸਵਾਲਾਂ ਦਾ ਮੇਲ ਕਰੋ',
  'paperName': 'ਕਾਗਜ਼ ਦਾ ਨਾਮ',
  'vettedWarning': 'ਹੇਠਾਂ ਦਿੱਤੇ ਸਵਾਲਾਂ ਦੀ ਭਾਈਚਾਰੇ ਦੁਆਰਾ ਜਾਂਚ ਨਹੀਂ ਕੀਤੀ ਗਈ ਹੈ, ਕੀ ਤੁਸੀਂ ਅਜੇ ਵੀ ਜਾਰੀ ਰੱਖਣਾ ਚਾਹੋਗੇ?',
  'requested': 'ਬੇਨਤੀ ਕੀਤੀ',
  'selected': 'ਚੁਣਿਆ ਹੋਇਆ',
  'noPapersGenerated': 'ਅਜੇ ਤੱਕ ਕੋਈ ਪ੍ਰਸ਼ਨ ਪੱਤਰ ਤਿਆਰ ਨਹੀਂ ਹੋਏ ਹਨ',
  'noTemplatesSaved': 'ਤੁਸੀਂ ਕੋਈ ਵੀ ਟੈਂਪਲੇਟ ਸੁਰੱਖਿਅਤ ਨਹੀਂ ਕੀਤੇ ਹਨ',
  'savePrompt': 'ਇਸ ਖੋਜ ਨੂੰ ਟੈਂਪਲੇਟ ਦੇ ਰੂਪ ਵਿੱਚ ਸੁਰੱਖਿਅਤ ਕਰੋ',
  'save': 'ਸਾਵਾ',
  'downvoteModalHead': 'ਡਾਊਨਵੋਟ ਦਾ ਕਾਰਨ',
  'downvoteModalSubHead': 'ਕਿਰਪਾ ਕਰਕੇ ਸਵਾਲ ਨੂੰ ਡਾਊਨਵੋਟ ਕਰਨ ਦਾ ਕਾਰਨ ਪ੍ਰਦਾਨ ਕਰੋ',
  'cancel': 'ਰੱਦ ਕਰੋ',
  'noSpeechSupport': 'ਬ੍ਰਾਊਜ਼ਰ ਬੋਲੀ ਪਛਾਣ ਦਾ ਸਮਰਥਨ ਨਹੀਂ ਕਰਦਾ',
  'uploadCSV': 'CSV ਫ਼ਾਈਲ ਅੱਪਲੋਡ ਕਰੋ',
  'submitFile': 'ਫਾਈਲਾਂ ਜਮ੍ਹਾਂ ਕਰੋ',
  'downloadSample': 'ਨਮੂਨਾ ਡਾਊਨਲੋਡ ਕਰੋ',
  'sorryNote': 'ਸਾਨੂੰ ਅਫ਼ਸੋਸ ਹੈ! ਇਸ ਪੇਪਰ ਲਈ ਕੋਈ ਸਵਾਲ ਨਹੀਂ ਮਿਲੇ। ਹੋ ਸਕਦਾ ਹੈ ਕਿ ਉਹਨਾਂ ਨੂੰ ਕਮਿਊਨਿਟੀ ਦੁਆਰਾ ਅਵੈਧ ਵਜੋਂ ਚਿੰਨ੍ਹਿਤ ਕੀਤਾ ਗਿਆ ਹੋਵੇ ਅਤੇ ਇਸ ਲਈ ਸਾਡੇ ਸਰਵਰਾਂ ਤੋਂ ਮਿਟਾ ਦਿੱਤਾ ਗਿਆ ਹੋਵੇ।', 'extraQuestions': 'ਵਾਧੂ ਸਵਾਲਾਂ ਦਾ %'},
 'தமிழ்': {'language': 'மொழியை மாற்றவும்',
  'qbag': 'கேள்வி வங்கி ஜெனரேட்டர்',
  'qbagDescp1': 'கேள்வி வங்கி ஜெனரேட்டர், ஒரு பெரிய அளவிலான புறநிலை கேள்விகளிலிருந்து கேள்வி வங்கிகளைத் தயாரிக்க, கூட்டத்தை ஆதாரப்படுத்தும் மாதிரியைப் பயன்படுத்துகிறது. எங்கள் தானியங்கு மற்றும் வலுவான அமைப்பைப் பயன்படுத்தி நம்பகமான வினாத்தாள்களை உருவாக்குவதற்கு QBaG ஒரு இடைமுகத்தை காகித அமைப்பாளர்கள் மற்றும் கல்வியாளர்களுக்கு வழங்குகிறது. கேள்விகள் பல அளவுருக்களின் அடிப்படையில் தேர்ந்தெடுக்கப்படலாம் மற்றும் சில நிமிடங்களில் நீங்கள் விரும்பிய வடிவமைப்பிற்கு ஏற்றுமதி செய்யலாம். பங்களிக்கப்பட்ட ஒவ்வொரு கேள்வியும் பல காசோலைகள் மூலம் அனுப்பப்பட்டு நிபுணர்களால் சரிபார்க்கப்படுகிறது.',
  'qbagDescp2': 'இந்த ஆப்ஸ் டீம்-எக்ஸிகியூட்டபிள்ஸ் மூலம் உருவாக்கப்பட்டது',
  'homeBanner1': 'திரளான கேள்விகள்',
  'homeBanner1.2': 'பல்வேறு ஆதாரங்களில் இருந்து கேள்விகளைப் பெறுங்கள்',
  'homeBanner1.3': 'க்ரவுட்சோர்சிங் அனைத்து பயனர்களையும் பங்களிக்க உதவுகிறது, இது பல பார்வைகளை சேகரிக்க உதவுகிறது மற்றும் கேள்விகளின் காப்பகத்தை வேறுபடுத்துகிறது. க்ரவுட்சோர்சிங் என்பது நிர்வாகச் சுமையைக் குறைக்கிறது, ஏனெனில் முக்கிய வேலைகள் கணினியால் கையாளப்படுகிறது, இது பயனரை கைமுறை வேலையிலிருந்து விடுவிக்கிறது.',
  'homeBanner2': 'நம்பகமான கேள்விகள்',
  'homeBanner2.2': 'சரிபார்க்கப்பட்ட மற்றும் சரிபார்க்கப்பட்ட கேள்விகள்',
  'homeBanner2.3': 'பங்களிக்கப்பட்ட ஒவ்வொரு கேள்வியும் தொடர்ச்சியான தானியங்கு சோதனை மூலம் கடந்து செல்கிறது, பின்னர் அது நிபுணர்களால் ஆராயப்படுகிறது',
  'homeBanner3': 'ஏற்றுமதி',
  'homeBanner3.2': 'கேள்விகளை விரும்பிய வடிவத்தில் ஏற்றுமதி செய்யவும்',
  'homeBanner3.3': 'தேர்ந்தெடுக்கப்பட்ட கேள்விகளை வினாத்தாளாக மாற்றி PDF, CSV அல்லது Excel வடிவத்திற்கு ஏற்றுமதி செய்யலாம்.',
  'homeBanner4': 'வடிகட்டுதல் விருப்பங்கள்',
  'homeBanner4.2': 'பல்வேறு கேள்விகளில் இருந்து தேர்வு செய்யவும்',
  'homeBanner4.3': 'தேர்ந்தெடுக்கப்பட்ட கேள்விகளின் சரியான பட்டியலைப் பெற, போர்டு, வகுப்பு, சிரமம், மதிப்பெண்கள், கேள்விகளின் எண்ணிக்கை மற்றும் பிற அளவுருக்கள் ஆகியவற்றின் அடிப்படையில் கேள்விகளை வடிகட்டி தேர்வு செய்யவும்.',
  'qbagDescp3': 'இப்போது உங்கள் கணக்கை உருவாக்கவும், QBaG ஐ உங்கள் காகித செட்டர் உதவியாளராகப் பயன்படுத்தவும்.',
  'qbagDescp4': 'QBaG இன் கூடுதல் அம்சங்களை ஆராய, தொடங்குவதற்கு ஒரு கணக்கை உருவாக்கவும்.',
  'footer': 'எங்களைப் பின்தொடரவும்',
  'register': 'பதிவு',
  'login': 'உள்நுழைய',
  'name': 'குடும்ப பெயர்',
  'employment': 'வேலைவாய்ப்பு',
  'dragNDropProof': "'n' இழுக்கவும் அல்லது சரியான அடையாளச் சான்றினைத் தேர்ந்தெடுக்கவும்",
  'uploadPhotoID': 'புகைப்பட ஐடியைப் பதிவேற்றவும்',
  'email': 'மின்னஞ்சல் முகவரி',
  'userType': 'பயனர் வகை',
  'teacherType': 'ஆசிரியர்',
  'othersType': 'மற்றவைகள்',
  'schoolCollege': 'பள்ளி/கல்லூரி',
  'position': 'பதவி',
  'education': 'கல்வி',
  'password': 'கடவுச்சொல்',
  'forgotPassword': 'கடவுச்சொல்லை மறந்துவிட்டீர்களா?',
  'dontHaveAnAccountSignUp': 'கணக்கு இல்லையா? பதிவு செய்யவும்',
  'alreadyHaveAnAccountSignIn': 'ஏற்கனவே ஒரு கணக்கு உள்ளதா? உள்நுழையவும்',
  'addQuestion': 'கேள்வியைச் சேர்க்கவும்',
  'searchQuestion': 'தேடல் கேள்வி',
  'generateQuestionPaper': 'வினாத்தாளை உருவாக்கவும்',
  'viewPastPapers': 'உருவாக்கப்பட்ட காகிதங்கள்',
  'noQuestionsFound': 'மன்னிக்கவும், கேள்விகள் எதுவும் இல்லை',
  'contributeQuestions': 'கேள்விகளை பங்களிக்கவும்',
  'myQuestions': 'எனது கேள்விகள்',
  'myTemplates': 'எனது டெம்ப்ளேட்கள்',
  'questionDetails': 'கேள்வி விவரங்கள்',
  'board': 'பலகை',
  'langMedium': 'பலகையின் ஊடகம்',
  'grade': 'கட்டம்',
  'questionType': 'கேள்வி வகை',
  'mcq': 'கொள்குறி வினாக்கள்',
  'oneWord': 'ஒரு சொல் அல்லது வாக்கியம்',
  'fillInTheBlanks': 'வெற்றிடங்களை நிரப்பவும்',
  'matchTheFollowing': 'பின்வருவனவற்றைப் பொருத்து',
  'difficulty': 'சிரமம்',
  'easy': 'சுலபம்',
  'medium': 'நடுத்தர',
  'hard': 'கடினமான',
  'mark': 'குறி',
  'marks': 'மதிப்பெண்கள்',
  'subject': 'பொருள்',
  'typeKeywordsAndPressEnter': 'தலைப்புகளைத் தட்டச்சு செய்து Enter ஐ அழுத்தவும்',
  'question': 'கேள்வி',
  'questions': 'கேள்விகள்',
  'numQuestions': 'கேள்விகளின் எண்ணிக்கை',
  'key': 'முக்கிய',
  'value': 'மதிப்பு',
  'addNew': 'புதிதாக சேர்க்கவும்',
  'remove': 'அகற்று',
  'answer': 'பதில்',
  'answers': 'பதில்கள்',
  'columnA': 'நெடுவரிசை ஏ',
  'columnB': 'நெடுவரிசை பி',
  'correctOption': 'சரியான விருப்பம்',
  'wrongOpts': 'தவறான விருப்பங்கள்',
  'wrongOption': 'தவறான விருப்பங்களைத் தட்டச்சு செய்து Enter ஐ அழுத்தவும்',
  'back': 'மீண்டும்',
  'next': 'அடுத்தது',
  'enterQuestion': 'கேள்வியை உள்ளிடவும்',
  'addAnotherQuestion': 'மற்றொரு கேள்வியைச் சேர்க்கவும்',
  'enterQuestionSuccess': 'உங்கள் கேள்விக்கு நன்றி.',
  'enterQuestionError': 'அச்சச்சோ! இதே போன்ற கேள்வி ஏற்கனவே உள்ளது!',
  'search': 'தேடு',
  'exportPDF': 'PDF க்கு அச்சிடவும்',
  'reviewQuestion': 'மதிப்பாய்வு கேள்வி',
  'submitQuestion': 'கேள்வியை சமர்ப்பிக்கவும்',
  'invalidRegistration': 'தவறான பதிவு தரவு! தயவுசெய்து மீண்டும் முயற்சி செய்க',
  'verifyEmail': 'கொடுக்கப்பட்ட மின்னஞ்சல் முகவரிக்கு மின்னஞ்சல் சரிபார்ப்பு இணைப்பு அனுப்பப்பட்டுள்ளது.\nகணக்கு அமைவை முடிக்க உங்கள் மின்னஞ்சலைச் சரிபார்க்கவும்.\nசரிபார்ப்பு இணைப்பு 24 மணிநேரத்திற்கு செல்லுபடியாகும்',
  'loginError1': 'தவறான உள்நுழைவு சான்றுகள்! தயவுசெய்து மீண்டும் முயற்சி செய்க',
  'loginError2': 'உங்கள் மின்னஞ்சலை சரிபார்க்கவும்! உங்கள் இன்பாக்ஸை பார்க்கவும்',
  'dashboard': 'டாஷ்போர்டு',
  'viewIDProof': 'அடையாளச் சான்றினைப் பார்க்கவும்',
  'changePassword': 'கடவுச்சொல்லை மாற்று',
  'changePasswordError': 'பழைய கடவுச்சொல் தவறானது. தயவுசெய்து மீண்டும் முயற்சி செய்க',
  'oldPassword': 'பழைய கடவுச்சொல்',
  'newPassword': 'புதிய கடவுச்சொல்',
  'confirmNewPassword': 'புதிய கடவு சொல்லை உறுதி செய்',
  'logout': 'வெளியேறு',
  'ok': 'சரி',
  'submit': 'சமர்ப்பிக்கவும்',
  'change': 'மாற்றவும்',
  'backToHome': 'முகப்புக்குத் திரும்பு',
  'pageNotFound': 'பக்கம் கிடைக்கவில்லை',
  'getResetLink': 'உங்கள் கடவுச்சொல் மீட்டமைப்பு இணைப்பைப் பெற மின்னஞ்சலை உள்ளிடவும்',
  'enterNewPassword': 'உங்கள் புதிய கடவுச்சொல்லை உள்ளிடவும்',
  'resetPasswordAlertTitle': 'கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது',
  'resetPasswordAlertDescription': 'உங்கள் கடவுச்சொல் வெற்றிகரமாக மீட்டமைக்கப்பட்டது.\nஉள்நுழைய தொடரவும்',
  'resetPasswordError': 'மீட்டமைவு இணைப்பு காலாவதியானது! தயவுசெய்து மீண்டும் முயற்சி செய்க',
  'forgotPasswordError': 'தவறான மின்னஞ்சல் ஐடி! தயவுசெய்து மீண்டும் முயற்சி செய்க',
  'forgotPasswordAlertTitle': 'கடவுச்சொல் இணைப்பை மீட்டமைக்கவும்',
  'forgotPasswordAlertDescription': 'கொடுக்கப்பட்ட மின்னஞ்சல் முகவரியில் கடவுச்சொல்லை மீட்டமைக்கும் இணைப்பு அனுப்பப்பட்டுள்ளது.\nஉங்கள் புதிய கடவுச்சொல்லை அமைக்க இணைப்பை கிளிக் செய்யவும்.\nமீட்டமைப்பு இணைப்பு 24 மணிநேரத்திற்கு செல்லுபடியாகும்',
  'selectQuestions': 'கேள்விகளைத் தேர்ந்தெடுக்கவும்',
  'selectedQuestions': 'கேள்விகள் தேர்ந்தெடுக்கப்பட்டன',
  'reviewQuestions': 'கேள்விகளை மதிப்பாய்வு செய்யவும்',
  'generatePaper': 'காகிதத்தை உருவாக்கவும்',
  'savePaper': 'காகிதத்தை சேமிக்கவும்',
  'easyQuestions': 'எளிதான கேள்விகளின் எண்ணிக்கை',
  'mediumQuestions': 'நடுத்தர கேள்விகளின் எண்ணிக்கை',
  'hardQuestions': 'கடினமான கேள்விகளின் எண்ணிக்கை',
  'totalQuestions': 'கேள்விகளின் மொத்த எண்ணிக்கை',
  'totalMarks': 'மொத்த மதிப்பெண்கள்',
  'mcqs': 'பல தேர்வு கேள்விகளின் எண்ணிக்கை',
  'oneWords': 'ஒரு வார்த்தை/வாக்கியக் கேள்விகளின் எண்ணிக்கை',
  'fillInTheBlankss': 'எண். வெற்றிட கேள்விகளை நிரப்பவும்',
  'matchTheFollowings': 'எண். பின்வரும் கேள்விகளைப் பொருத்தவும்',
  'paperName': 'காகித பெயர்',
  'vettedWarning': 'பின்வரும் கேள்விகள் சமூகத்தால் சரிபார்க்கப்படவில்லை, நீங்கள் இன்னும் தொடர விரும்புகிறீர்களா?',
  'requested': 'கோரப்பட்டது',
  'selected': 'தேர்ந்தெடுக்கப்பட்டது',
  'noPapersGenerated': 'இன்னும் வினாத்தாள்கள் எதுவும் உருவாக்கப்படவில்லை',
  'noTemplatesSaved': 'நீங்கள் எந்த டெம்ப்ளேட்களையும் சேமிக்கவில்லை',
  'savePrompt': 'இந்த தேடலை டெம்ப்ளேட்டாக சேமிக்கவும்',
  'save': 'சவா',
  'downvoteModalHead': 'ஓட்டு போடாததற்கான காரணம்',
  'downvoteModalSubHead': 'கேள்விக்கு வாக்களிக்காததற்கான காரணத்தை வழங்கவும்',
  'cancel': 'ரத்து செய்',
  'noSpeechSupport': 'பேச்சு அங்கீகாரத்தை உலாவி ஆதரிக்காது',
  'uploadCSV': 'CSV கோப்பைப் பதிவேற்றவும்',
  'submitFile': 'கோப்புகளை சமர்ப்பிக்கவும்',
  'downloadSample': 'மாதிரியைப் பதிவிறக்கவும்',
  'sorryNote': 'எங்களை மன்னித்து விடுங்கள்! இந்தத் தாளுக்கான கேள்விகள் எதுவும் இல்லை. அவை சமூகத்தால் செல்லாததாகக் குறிக்கப்பட்டு, எங்கள் சேவையகங்களிலிருந்து நீக்கப்பட்டிருக்கலாம்.', 'extraQuestions': 'கூடுதல் கேள்விகளின் %'},
 'తెలుగు': {'language': 'భాష మార్చు',
  'qbag': 'ప్రశ్న బ్యాంక్ జనరేటర్',
  'qbagDescp1': 'క్వశ్చన్ బ్యాంక్ జనరేటర్ పెద్ద మొత్తంలో ఆబ్జెక్టివ్ ప్రశ్నల నుండి ప్రశ్న బ్యాంకులను సిద్ధం చేయడానికి క్రౌడ్ సోర్సింగ్ మోడల్\u200cను ఉపయోగిస్తుంది. QBaG మా ఆటోమేటెడ్ మరియు పటిష్టమైన సిస్టమ్\u200cను ఉపయోగించి నమ్మకమైన ప్రశ్న పత్రాలను రూపొందించడానికి పేపర్ సెట్టర్\u200cలు మరియు విద్యావేత్తలకు ఇంటర్\u200cఫేస్\u200cను అందిస్తుంది. ప్రశ్నలను పారామితుల పరిధి ఆధారంగా ఎంచుకోవచ్చు మరియు నిమిషాల్లో మీరు కోరుకున్న ఫార్మాట్\u200cకు ఎగుమతి చేయవచ్చు. అందించిన ప్రతి ప్రశ్న అనేక తనిఖీల ద్వారా పంపబడుతుంది మరియు నిపుణులచే కూడా పరిశీలించబడుతుంది.',
  'qbagDescp2': 'ఈ యాప్ టీమ్-ఎగ్జిక్యూటబుల్స్ ద్వారా రూపొందించబడింది',
  'homeBanner1': 'క్రౌడ్\u200cసోర్స్\u200cడ్ ప్రశ్నలు',
  'homeBanner1.2': 'వివిధ మూలాల నుండి ప్రశ్నలను పొందండి',
  'homeBanner1.3': 'క్రౌడ్\u200cసోర్సింగ్ వినియోగదారులందరినీ సహకరించేలా చేస్తుంది, ఇది బహుళ దృక్కోణాలను సేకరించడంలో సహాయపడుతుంది మరియు ప్రశ్నల ఆర్కైవ్\u200cను వైవిధ్యపరుస్తుంది. క్రౌడ్\u200cసోర్సింగ్ నిర్వహణ భారాన్ని తగ్గిస్తుంది, ప్రధాన పనిని సిస్టమ్ ద్వారా నిర్వహించబడుతుంది, ఇది వినియోగదారుని మాన్యువల్ పని నుండి విముక్తి చేస్తుంది',
  'homeBanner2': 'నమ్మదగిన ప్రశ్నలు',
  'homeBanner2.2': 'ధృవీకరించబడిన మరియు ధృవీకరించబడిన ప్రశ్నలు',
  'homeBanner2.3': 'అందించిన ప్రతి ప్రశ్న స్వయంచాలక పరీక్షల శ్రేణిలో ఉత్తీర్ణత సాధించి, ఆపై నిపుణులచే పరిశీలించబడుతుంది',
  'homeBanner3': 'ఎగుమతి',
  'homeBanner3.2': 'కావలసిన ఫార్మాట్\u200cలో ప్రశ్నలను ఎగుమతి చేయండి',
  'homeBanner3.3': 'ఎంచుకున్న ప్రశ్నలను ప్రశ్నపత్రంగా మార్చవచ్చు మరియు PDF, CSV లేదా ఎక్సెల్ ఫార్మాట్\u200cలోకి ఎగుమతి చేయవచ్చు',
  'homeBanner4': 'వడపోత ఎంపికలు',
  'homeBanner4.2': 'వివిధ ప్రశ్నల నుండి ఎంచుకోండి',
  'homeBanner4.3': 'క్యూరేటెడ్ ప్రశ్నల ఖచ్చితమైన జాబితాను పొందడానికి బోర్డు, తరగతి, కష్టం, మార్కులు, ప్రశ్నల సంఖ్య మరియు ఇతర పారామితుల ఆధారంగా ప్రశ్నలను ఫిల్టర్ చేయండి మరియు ఎంచుకోండి',
  'qbagDescp3': 'ఇప్పుడే మీ ఖాతాను సృష్టించండి మరియు QBaGని మీ పేపర్ సెట్టర్ అసిస్టెంట్\u200cగా ఉపయోగించండి.',
  'qbagDescp4': 'QBaG యొక్క మరిన్ని ఫీచర్లను అన్వేషించడానికి, ప్రారంభించడానికి ఖాతాను సృష్టించండి.',
  'footer': 'మమ్మల్ని అనుసరించండి',
  'register': 'నమోదు',
  'login': 'ప్రవేశించండి',
  'name': 'ఇంటిపేరు',
  'employment': 'ఉపాధి',
  'dragNDropProof': "'n' డ్రాగ్ చేయండి లేదా చెల్లుబాటు అయ్యే గుర్తింపు రుజువును ఎంచుకోండి",
  'uploadPhotoID': 'ఫోటో IDని అప్\u200cలోడ్ చేయండి',
  'email': 'ఇమెయిల్ చిరునామా',
  'userType': 'వినియోగదారు రకం',
  'teacherType': 'టీచర్',
  'othersType': 'ఇతరులు',
  'schoolCollege': 'పాఠశాల/కళాశాల',
  'position': 'స్థానం',
  'education': 'చదువు',
  'password': 'పాస్వర్డ్',
  'forgotPassword': 'పాస్\u200cవర్డ్ మర్చిపోయారా?',
  'dontHaveAnAccountSignUp': 'ఖాతా లేదా? చేరడం',
  'alreadyHaveAnAccountSignIn': 'ఖాతా కలిగి ఉన్నారా? సైన్ ఇన్ చేయండి',
  'addQuestion': 'ప్రశ్నను జోడించండి',
  'searchQuestion': 'శోధన ప్రశ్న',
  'generateQuestionPaper': 'ప్రశ్న పత్రాన్ని రూపొందించండి',
  'viewPastPapers': 'రూపొందించిన పేపర్లు',
  'noQuestionsFound': 'క్షమించండి, ప్రశ్నలు ఏవీ కనుగొనబడలేదు',
  'contributeQuestions': 'కంట్రిబ్యూట్ ప్రశ్నలు',
  'myQuestions': 'నా ప్రశ్నలు',
  'myTemplates': 'నా టెంప్లేట్లు',
  'questionDetails': 'ప్రశ్న వివరాలు',
  'board': 'బోర్డు',
  'langMedium': 'బోర్డు మాధ్యమం',
  'grade': 'గ్రిడ్',
  'questionType': 'ప్రశ్న రకం',
  'mcq': 'బహుళ ఎంపిక ప్రశ్నలు',
  'oneWord': 'ఒక పదం లేదా వాక్యం',
  'fillInTheBlanks': 'ఖాళీలు పూరించడానికి',
  'matchTheFollowing': 'కింది వాటిని సరిపోల్చండి',
  'difficulty': 'కష్టం',
  'easy': 'సులువు',
  'medium': 'మధ్యస్థం',
  'hard': 'కష్టం',
  'mark': 'మార్క్',
  'marks': 'మార్కులు',
  'subject': 'విషయం',
  'typeKeywordsAndPressEnter': 'టాపిక్స్ అని టైప్ చేసి ఎంటర్ నొక్కండి',
  'question': 'ప్రశ్న',
  'questions': 'ప్రశ్నలు',
  'numQuestions': 'ప్రశ్నల సంఖ్య',
  'key': 'కీ',
  'value': 'విలువ',
  'addNew': 'కొత్తది జత పరచండి',
  'remove': 'తొలగించు',
  'answer': 'సమాధానం',
  'answers': 'సమాధానాలు',
  'columnA': 'కాలమ్ A',
  'columnB': 'కాలమ్ B',
  'correctOption': 'సరైన ఎంపిక',
  'wrongOpts': 'తప్పు ఎంపికలు',
  'wrongOption': 'తప్పు ఎంపికలను టైప్ చేసి, ఎంటర్ నొక్కండి',
  'back': 'వెనుకకు',
  'next': 'తరువాత',
  'enterQuestion': 'ప్రశ్నను నమోదు చేయండి',
  'addAnotherQuestion': 'మరొక ప్రశ్నను జోడించండి',
  'enterQuestionSuccess': 'మీ ప్రశ్నకు ధన్యవాదాలు.',
  'enterQuestionError': 'అయ్యో! ఇలాంటి ప్రశ్న ఇప్పటికే ఉంది!',
  'search': 'వెతకండి',
  'exportPDF': 'PDFకి ప్రింట్ చేయండి',
  'reviewQuestion': 'సమీక్ష ప్రశ్న',
  'submitQuestion': 'ప్రశ్నను సమర్పించండి',
  'invalidRegistration': 'చెల్లని నమోదు డేటా! దయచేసి మళ్లీ ప్రయత్నించండి',
  'verifyEmail': 'ఇచ్చిన ఇమెయిల్ చిరునామాపై ఇమెయిల్ ధృవీకరణ లింక్ పంపబడింది.\nఖాతా సెటప్\u200cను పూర్తి చేయడానికి దయచేసి మీ ఇమెయిల్\u200cను ధృవీకరించండి.\nధృవీకరణ లింక్ 24 గంటల వరకు చెల్లుబాటు అవుతుంది',
  'loginError1': 'చెల్లని లాగిన్ ఆధారాలు! దయచేసి మళ్లీ ప్రయత్నించండి',
  'loginError2': 'దయచేసి మీ ఇమెయిల్\u200cని ధృవీకరించండి! నీ ఇన్ బాక్స్ చూసుకో',
  'dashboard': 'డాష్బోర్డ్',
  'viewIDProof': 'ID రుజువును వీక్షించండి',
  'changePassword': 'పాస్వర్డ్ మార్చండి',
  'changePasswordError': 'పాత పాస్\u200cవర్డ్ తప్పు. దయచేసి మళ్లీ ప్రయత్నించండి',
  'oldPassword': 'పాత పాస్\u200cవర్డ్',
  'newPassword': 'కొత్త పాస్వర్డ్',
  'confirmNewPassword': 'కొత్త పాస్\u200cవర్డ్\u200cని నిర్ధారించండి',
  'logout': 'లాగ్ అవుట్ చేయండి',
  'ok': 'అలాగే',
  'submit': 'సమర్పించండి',
  'change': 'మార్చు',
  'backToHome': 'తిరిగి ఇంటికి',
  'pageNotFound': 'పేజీ కనుగొనబడలేదు',
  'getResetLink': 'మీ పాస్\u200cవర్డ్ రీసెట్ లింక్\u200cని పొందడానికి ఇమెయిల్\u200cను నమోదు చేయండి',
  'enterNewPassword': 'మీ కొత్త పాస్\u200cవర్డ్\u200cని నమోదు చేయండి',
  'resetPasswordAlertTitle': 'పాస్\u200cవర్డ్ విజయవంతంగా మార్చబడింది',
  'resetPasswordAlertDescription': 'మీ పాస్\u200cవర్డ్ విజయవంతంగా రీసెట్ చేయబడింది.\nదయచేసి లాగిన్ చేయడానికి కొనసాగండి',
  'resetPasswordError': 'రీసెట్ లింక్ గడువు ముగిసింది! దయచేసి మళ్లీ ప్రయత్నించండి',
  'forgotPasswordError': 'చెల్లని ఇమెయిల్ ID! దయచేసి మళ్లీ ప్రయత్నించండి',
  'forgotPasswordAlertTitle': 'పాస్\u200cవర్డ్ లింక్\u200cని రీసెట్ చేయండి',
  'forgotPasswordAlertDescription': 'ఇచ్చిన ఇమెయిల్ చిరునామాకు రీసెట్ పాస్\u200cవర్డ్ లింక్ పంపబడింది.\nదయచేసి మీ కొత్త పాస్\u200cవర్డ్\u200cని సెట్ చేయడానికి లింక్\u200cపై క్లిక్ చేయండి.\nరీసెట్ లింక్ 24 గంటల వరకు చెల్లుబాటు అవుతుంది',
  'selectQuestions': 'ప్రశ్నలను ఎంచుకోండి',
  'selectedQuestions': 'ప్రశ్నలు ఎంపిక చేయబడ్డాయి',
  'reviewQuestions': 'ప్రశ్నలను సమీక్షించండి',
  'generatePaper': 'పేపర్\u200cని రూపొందించండి',
  'savePaper': 'పేపర్\u200cను సేవ్ చేయండి',
  'easyQuestions': 'సులభమైన ప్రశ్నల సంఖ్య',
  'mediumQuestions': 'మీడియం ప్రశ్నల సంఖ్య',
  'hardQuestions': 'కఠినమైన ప్రశ్నల సంఖ్య',
  'totalQuestions': 'మొత్తం ప్రశ్నల సంఖ్య',
  'totalMarks': 'మొత్తం మార్కులు',
  'mcqs': 'బహుళ ఎంపిక ప్రశ్నల సంఖ్య',
  'oneWords': 'ఒక పదం/వాక్య ప్రశ్నల సంఖ్య',
  'fillInTheBlankss': 'సంఖ్య. ఖాళీ ప్రశ్నలను పూరించండి',
  'matchTheFollowings': 'నం. కింది ప్రశ్నలను సరిపోల్చండి',
  'paperName': 'పేపర్ పేరు',
  'vettedWarning': 'కింది ప్రశ్నలు సంఘం ద్వారా పరిశీలించబడలేదు, మీరు ఇంకా కొనసాగించాలనుకుంటున్నారా?',
  'requested': 'అభ్యర్థించారు',
  'selected': 'ఎంపిక చేయబడింది',
  'noPapersGenerated': 'ఇంకా ప్రశ్న పత్రాలు రూపొందించబడలేదు',
  'noTemplatesSaved': 'మీరు ఏ టెంప్లేట్\u200cలను సేవ్ చేయలేదు',
  'savePrompt': 'ఈ శోధనను టెంప్లేట్\u200cగా సేవ్ చేయండి',
  'save': 'సావా',
  'downvoteModalHead': 'డౌన్\u200cవోట్\u200cకు కారణం',
  'downvoteModalSubHead': 'దయచేసి ప్రశ్నకు ఓటు వేయడానికి కారణాన్ని అందించండి',
  'cancel': 'రద్దు చేయండి',
  'noSpeechSupport': 'బ్రౌజర్ ప్రసంగ గుర్తింపుకు మద్దతు ఇవ్వదు',
  'uploadCSV': 'CSV ఫైల్\u200cను అప్\u200cలోడ్ చేయండి',
  'submitFile': 'ఫైళ్లను సమర్పించండి',
  'downloadSample': 'నమూనాను డౌన్\u200cలోడ్ చేయండి',
  'sorryNote': 'మమ్మల్ని క్షమించండి! ఈ పేపర్\u200cకు ప్రశ్నలు ఏవీ కనుగొనబడలేదు. సంఘం ద్వారా అవి చెల్లనివిగా గుర్తించబడి ఉండవచ్చు మరియు అందువల్ల మా సర్వర్\u200cల నుండి తొలగించబడి ఉండవచ్చు.', 'extraQuestions': '% అదనపు ప్రశ్నలు'}
}


const VOTES_THRESHOLD = 4

export default VOTES_THRESHOLD